import React, { useState, useContext ,useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { Input, InputNumber, Form, Button, Row, Col, Collapse, Card, Space, Popconfirm, message, Select, ConfigProvider, Modal, Tag } from 'antd';
import { FileOutlined, CheckCircleOutlined, WarningOutlined, LineHeightOutlined, PoweroffOutlined } from '@ant-design/icons';
import AppLayout from "./components/AdminLayout";
import { LanguageContext } from "./LanguageContext";
import CollapsePanel from 'antd/es/collapse/CollapsePanel';
import { Tooltip, Alert } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import PanelPreview from './PanelPreview';

const importAllIcons = (requireContext) => {
    let icons = {};
    requireContext.keys().forEach((key) => {
      const match = key.match(/\.\/(\d+)\.svg$/);
      if (match) {
        const iconKey = match[1];
        const importedIcon = requireContext(key);
        // Eğer modül default olarak export edilmişse onu, aksi halde direkt modülü alıyoruz.
        icons[iconKey] = importedIcon.default || importedIcon;
      }
    });
    return icons;
  };
  const icons = importAllIcons(require.context('./ikonlar', false, /\.svg$/));



const EditableJson = () => {
  const [form] = Form.useForm()
  const [iconModalVisible, setIconModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentOutputIndex, setCurrentOutputIndex] = useState(null);
  const [currentInputIndex, setCurrentInputIndex] = useState(null);
  const [currentVoltageIndex, setCurrentVoltageIndex] = useState(null);
  const [currentFloatIndex, setCurrentFloatIndex] = useState(null);
  const [currentTempratureIndex, setCurrentTempratureIndex] = useState(null); 
  const { language, translations } = useContext(LanguageContext);
  const [configName, setConfigName] = useState('');
  const [vehicleName, setVehicleName] = useState('');

  const [isComponentTypeModalVisible, setIsComponentTypeModalVisible] = useState(false);
const [selectedSlotInfo, setSelectedSlotInfo] = useState(null);
const [selectedComponentType, setSelectedComponentType] = useState(null);
const [selectedVersion, setSelectedVersion] = useState("");


      const outputRefs = useRef([]);
const inputRefs = useRef([]);
const voltageRefs = useRef([]);
const floatRefs = useRef([]);
const outputDebounceRef = useRef(null);
const inputDebounceRef = useRef(null);
const voltageDebounceRef = useRef(null);
const floatDebounceRef = useRef(null);
const [activeCollapseKeys, setActiveCollapseKeys] = useState(['1', '2', '3']);
const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    const storedVersion = localStorage.getItem("userVersion");
    if (storedVersion) {
      setSelectedVersion(storedVersion);
    }
  }, []);

const handleEmptySlotClick = (page, row, column) => {
  setSelectedSlotInfo({ page, row, column });
  setIsComponentTypeModalVisible(true);
};

const handleSelectComponentType = (type) => {
  setSelectedComponentType(type);
  setIsComponentTypeModalVisible(false);
  
  // İlgili paneli aç
  const panelKeys = {
    'output': '1',
    'input': '3',
    'voltage': '4',
    'float': '5'
  };


  
  const panelKey = panelKeys[type];
  if (!activeCollapseKeys.includes(panelKey)) {
    setActiveCollapseKeys([...activeCollapseKeys, panelKey]);
  }
  
  // Panel açıldıktan sonra ilgili "Ekle" butonuna scroll yap
  setTimeout(() => {
    let buttonId;
    switch(type) {
      case 'output':
        buttonId = 'add-output-button';
        break;
      case 'input':
        buttonId = 'add-input-button';
        break;
      case 'voltage':
        buttonId = 'add-voltage-button';
        break;
      case 'float':
        buttonId = 'add-float-button';
        break;
    }
    
    const buttonElement = document.getElementById(buttonId);
    if (buttonElement) {
      buttonElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Buton etrafında animasyon efekti
      buttonElement.style.transform = 'scale(1.05)';
      buttonElement.style.transition = 'transform 0.3s ease';
      setTimeout(() => {
        buttonElement.style.transform = 'scale(1)';
      }, 500);
    }
  }, 400); // Panel'in açılması için biraz bekle
  
  message.info(`${type.toUpperCase()} ${translations[language].turuncudalga}`, 4);
};

   const location = useLocation();
  const { configString, configId, configName: initialConfigName } = location.state || {};

  const checkIfPageHasItems = (pageNo) => {
  const allItems = [
    ...outputs,
    ...inputs,
    ...voltages,
    ...floats
  ];

  return allItems.some(item => {
    // Ana pozisyon kontrolü
    if (item.page === pageNo) return true;
    // Klon pozisyon kontrolü
    if (item.cloneActive && item.page2 === pageNo) return true;
    return false;
  });
};

const checkIfPositionUsedInCapacity = (pageNo, rowNo, proposedCapacity) => {
  const usedItems = [];
  const allItems = [
    ...outputs.map((item, index) => ({ ...item, type: 'output', index: index + 1 })),
    ...inputs.map((item, index) => ({ ...item, type: 'input', index: index + 1 })),
    ...voltages.map((item, index) => ({ ...item, type: 'voltage', index: index + 1 })),
    ...floats.map((item, index) => ({ ...item, type: 'float', index: index + 1 }))
  ];

  // Ana pozisyonları kontrol et
  allItems.forEach(item => {
    if (item.page === pageNo && item.row === rowNo) {
      if (item.column > proposedCapacity) {
        usedItems.push(`${item.type} ${item.index} (Kolon ${item.column})`);
      }
    }
  });

  // Clone pozisyonlarını kontrol et
  allItems.forEach(item => {
    if (item.cloneActive && item.page2 === pageNo && item.row2 === rowNo) {
      if (item.column2 > proposedCapacity) {
        usedItems.push(`${item.type} ${item.index} Clone (Kolon ${item.column2})`);
      }
    }
  });

  return usedItems;
};

const findSafePosition = (pageNo, itemType, currentItemIndex) => {
  const pageData = getPageData(pageNo);
  const usedPositions = getUsedPositions();
  
  // Tüm mümkün pozisyonları kontrol et
  for (let row = 1; row <= 2; row++) {
    const maxColumns = row === 1 ? pageData.first_row_capacity : pageData.second_row_capacity;
    
    // Bu sıra boşsa atla
    if (maxColumns <= 0) continue;
    
    for (let col = 1; col <= maxColumns; col++) {
      const positionKey = `${pageNo}-${row}-${col}`;
      
      // Bu pozisyon kullanılmamışsa güvenli
      if (!usedPositions.has(positionKey)) {
        return { row, column: col };
      }
    }
  }
  
  // Güvenli pozisyon bulunamadı, undefined döndür
  return { row: undefined, column: undefined };
};

  const handleIconSelect = (iconNumber) => {
    if (currentOutputIndex !== null) {
      const updatedOutputs = [...outputs];
      updatedOutputs[currentOutputIndex].icon = iconNumber;
      setOutputs(updatedOutputs);
      setIconModalVisible(false);
      setCurrentOutputIndex(null);
    };
    if(currentTempratureIndex !== null) {
      const updatedTempratures = [...tempratures];
      updatedTempratures[currentTempratureIndex].icon = iconNumber;
      setTempratures(updatedTempratures);
      setIconModalVisible(false);
      setCurrentTempratureIndex(null);
    }
    if (currentFloatIndex !== null) {
        const updatedFloats = [...floats];
        updatedFloats[currentFloatIndex].icon = iconNumber;
        setFloats(updatedFloats);
        setIconModalVisible(false);
        setCurrentFloatIndex(null);
    };
    if (currentVoltageIndex !== null) {
        const updatedVoltages = [...voltages];
        updatedVoltages[currentVoltageIndex].icon = iconNumber;
        setVoltages(updatedVoltages);
        setIconModalVisible(false);
        setCurrentVoltageIndex(null);
    };
    if (currentInputIndex !== null) {
        const updatedInputs = [...inputs];
        updatedInputs[currentInputIndex].icon = iconNumber;
        setInputs(updatedInputs);
        setIconModalVisible(false);
        setCurrentInputIndex(null);
    };
  };

  const [selectedIcon, setSelectedIcon] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);      

  const handleMouseEnter = (icon) => {
    setHoveredIcon(icon);
  };

  const handleMouseLeave = () => {
    setHoveredIcon(null);
  };

  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const [formValues, setFormValues] = useState({
    first_row_capacity: 4,
    second_row_capacity: 4
  });

  // Karanlık mod açma-kapama fonksiyonu
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Karanlık mod için Ant Design tema ayarları
  const darkTheme = {
    token: {
      colorBgBase: '#141414', // Temel arka plan rengi
      colorTextBase: '#ffffff', // Metin rengi
      colorLink: '#1890ff', // Link rengi
      colorPrimary: '#1890ff', // Birincil renk
    },
  };

    const allSocketPins = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
         "B5", "B8",
         "C6", "C7", "C8",
         "D0", "D1", "D2"];
         
  const allFloatsPins = ["B6", "B7", "C1", "C2", "C3"];
  const allInputPins = ["B4", "B3", "B2", "B1"];
  const allVoltagesPins = ["00",
         "C1", "C2", "C3", "C4"];

  const allOutputPins = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
         "B1", "B8",
         "C6", "C7", "C8",
         "D0", "D1", "D2"];
  
  const [outputs, setOutputs] = useState([
{
  socketpin: "A1",
  type: "enabled",
  currentlimit: 10000,
  currentgreenlimit: 100,
  page: 1,
  row: 2,
  column: 1,
  icon: 1,
  nameTR: "Buzdolabı",
  nameGB: "Fridge",
  nameDE: "Kühlschrank",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Refrigerador",
    nameRU: "Холодильник",
    nameGR: "Ψυγείο",
    nameFR: "Réfrigérateur",
    nameIT: "Frigorifero",
    namePT: "Geladeira",
    nameSA: "ثلاجة"
  }),
  cloneActive: false, 
}
  ]);

  const handleCloneOutput = (index) => {
  const updatedOutputs = [...outputs];
  if (!updatedOutputs[index].cloneActive) {
    updatedOutputs[index].cloneActive = true;
    
    // Ana pozisyon ile aynı sayfa üzerinde güvenli pozisyon bul
    const safePosition = findSafePosition(updatedOutputs[index].page, 'output', index);
    updatedOutputs[index].page2 = updatedOutputs[index].page;
    updatedOutputs[index].row2 = safePosition.row;
    updatedOutputs[index].column2 = safePosition.column;
  }
  setOutputs(updatedOutputs);
};

  const handleRemoveCloneOutput = (index) => {
    const updatedOutputs = [...outputs];
    if (updatedOutputs[index].cloneActive) {
      updatedOutputs[index].cloneActive = false;
      delete updatedOutputs[index].page2;
      delete updatedOutputs[index].row2;
      delete updatedOutputs[index].column2;
    }
    setOutputs(updatedOutputs);
  };
  
  const [tempratures, setTempratures] = useState([
    {
      no : 1,
      enable : "true",
      icon : 44,
      side : "left"
    },
    {
      no : 2,
      enable : "true",
      icon : 43,
      side : "right"
    },
  ]);

  const handleAddTemrature = () =>{
    const newTemprature = {
      no : 1,
      enable : "true",
      icon : 44,
      side : "left"
    };
    setTempratures([...tempratures, newTemprature]);
  };

  // Konum değiştirildiğinde aynı tarafa atanmış diğer sensörle otomatik yer değiştirir
  const handleTemperatureSideChange = (index, newSide) => {
    const updated = [...tempratures];
    const oldSide = updated[index].side;
    updated[index] = { ...updated[index], side: newSide };

    if (oldSide !== newSide) {
      for (let i = 0; i < updated.length; i++) {
        if (i !== index && updated[i].side === newSide) {
          updated[i] = { ...updated[i], side: oldSide };
          break;
        }
      }
    }

    setTempratures(updated);
  };


const handleComponentClick = (component) => {
  // Önce doğru collapse panel'i aç
  let panelKey;
  switch (component.type) {
    case 'output':
      panelKey = '1';
      break;
    case 'input':
      panelKey = '3';
      break;
    case 'voltage':
      panelKey = '4';
      break;
    case 'float':
      panelKey = '5';
      break;
    default:
      return;
  }
  
  // Panel'i aç
  if (!activeCollapseKeys.includes(panelKey)) {
    setActiveCollapseKeys([...activeCollapseKeys, panelKey]);
  }
  
  // Scroll için setTimeout kullan (panel açılması için bekle)
  setTimeout(() => {
    let targetElement;
    let targetArray;
    
    switch (component.type) {
      case 'output':
        targetArray = outputs;
        break;
      case 'input':
        targetArray = inputs;
        break;
      case 'voltage':
        targetArray = voltages;
        break;
      case 'float':
        targetArray = floats;
        break;
    }
    
    // Socketpin'e göre index bul
    const index = targetArray.findIndex(item => item.socketpin === component.socketpin);
    
    if (index !== -1) {
      // Card ID'sine göre elementi bul
      const cardId = `${component.type}-card-${index}`;
      targetElement = document.getElementById(cardId);
      
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Highlight efekti
        targetElement.style.boxShadow = '0 0 0 4px #ffd591';
        targetElement.style.transition = 'box-shadow 0.3s ease';
        setTimeout(() => {
          targetElement.style.boxShadow = '';
        }, 2000);
      }
    }
  }, 300);
};



useEffect(() => {
  if (!configString) return;
  
  console.log('🔄 Config yükleniyor...');
  
  try {
    const cfg = JSON.parse(configString);

    if (cfg.vehicle_name) {
      setVehicleName(cfg.vehicle_name);
    }
    if (initialConfigName) {
      setConfigName(initialConfigName + " Update");
    }

    if (cfg.pages) {
      setPages(cfg.pages);
    }
    
    // Outputs - JSON'dan gelen değerleri olduğu gibi state'e kaydet
    const loadedOutputs = cfg.outputs
      ? cfg.outputs
          .filter(o => o.type !== "disable")
          .map(o => ({
            ...o,
            currentlimit: o.currentlimit || 10000,
            currentgreenlimit: o.currentgreenlimit || 9000,
            cloneActive: !!(o.page2 && o.row2 && o.column2)
          }))
      : [];
    
    const loadedInputs = cfg.inputs
      ? cfg.inputs
          .filter(i => i.enable !== "false" || (i.enable === "false" && i.vavienoutput)) // false ama vavienoutput varsa yükle
          .map(i => ({
            ...i,
            // Enable false ise pozisyon bilgilerini undefined yap
            page: i.enable === "false" ? undefined : i.page,
            row: i.enable === "false" ? undefined : i.row,
            column: i.enable === "false" ? undefined : i.column,
            cloneActive: i.enable === "true" && !!(i.page2 && i.row2 && i.column2)
          }))
      : [];
    
    const loadedVoltages = cfg.voltages
      ? cfg.voltages
          .filter(v => v.enable !== "false")
          .map(v => ({
            ...v,
            cloneActive: !!(v.page2 && v.row2 && v.column2)
          }))
      : [];
    
    const loadedFloats = cfg.floats
      ? cfg.floats
          .filter(f => f.enable !== "false")
          .map(f => ({
            ...f,
            warn_percent: f.warn_percent !== undefined ? f.warn_percent : 20,
            error_percent: f.error_percent !== undefined ? f.error_percent : 0,
            cloneActive: !!(f.page2 && f.row2 && f.column2)
          }))
      : [];
    
    const loadedRelays = cfg.relays ? [{
      ...cfg.relays,
      short_circuit_voltage: cfg.relays.short_circuit_voltage || 13200,
      open_circuit_voltage: cfg.relays.open_circuit_voltage || 12500,
      manualoverride_duration: cfg.relays.manualoverride_duration || 75
    }] : [{
      enable: "",
      short_circuit_socketpin: "",
      open_circuit_socketpin: "",
      short_circuit_voltage: 13200,
      open_circuit_voltage: 12500,
      manualoverride_duration: 75
    }];
    
    const loadedSettings = cfg.settings ? [{
      ...cfg.settings,
      force_shut_down_voltage: cfg.settings.force_shut_down_voltage || 10500,
      optional_down_voltage: cfg.settings.optional_down_voltage || 11000,
      start_warn_voltage: cfg.settings.start_warn_voltage || 11500,
      recover_voltage: cfg.settings.recover_voltage || 12000,
      force_shut_down_time: cfg.settings.force_shut_down_time || 60
    }] : [{
      force_shut_down_voltage: 10500,
      optional_down_voltage: 11000,
      start_warn_voltage: 11500,
      recover_voltage: 12000,
      force_shut_down_time: 60
    }];
    
    const loadedTempratures = cfg.tempratures || tempratures;

    console.log('📊 Yüklenen veriler:', {
      outputs: loadedOutputs,
      floats: loadedFloats,
      relays: loadedRelays,
      settings: loadedSettings
    });

    // State'leri set et
    setOutputs(loadedOutputs);
    setInputs(loadedInputs);
    setVoltages(loadedVoltages);
    setFloats(loadedFloats);
    setRelays(loadedRelays);
    setSettings(loadedSettings);
    setTempratures(loadedTempratures);

    // Form değerlerini hazırla (1000'e bölerek)
    const formValues = {};
    
    // Outputs
    loadedOutputs.forEach((output, index) => {
      formValues[`currentlimit_${index}`] = output.currentlimit / 1000;
      formValues[`currentgreenlimit_${index}`] = output.currentgreenlimit / 1000;
    });
    
    // Floats
    loadedFloats.forEach((float, index) => {
      formValues[`warn_percent_${index}`] = float.warn_percent;
      formValues[`error_percent_${index}`] = float.error_percent;
    });
    
    // Relays
    loadedRelays.forEach((relay, index) => {
      formValues[`short_circuit_voltage_${index}`] = relay.short_circuit_voltage / 1000;
      formValues[`open_circuit_voltage_${index}`] = relay.open_circuit_voltage / 1000;
      formValues[`manualoverride_duration_${index}`] = relay.manualoverride_duration;
    });
    
    // Settings
    loadedSettings.forEach((setting, index) => {
      formValues[`force_shut_down_voltage_${index}`] = setting.force_shut_down_voltage / 1000;
      formValues[`optional_down_voltage_${index}`] = setting.optional_down_voltage / 1000;
      formValues[`start_warn_voltage_${index}`] = setting.start_warn_voltage / 1000;
      formValues[`recover_voltage_${index}`] = setting.recover_voltage / 1000;
      formValues[`force_shut_down_time_${index}`] = setting.force_shut_down_time;
    });
    
    console.log('📝 Form değerleri (1000\'e bölünmüş):', formValues);
    
    // Form'a değerleri yükle
    setTimeout(() => {
      form.setFieldsValue(formValues);
      
      setTimeout(() => {
        console.log('✅ Form kontrolü:', form.getFieldsValue());
      }, 100);
    }, 0);

  } catch (err) {
    console.error("❌ JSON hatası:", err);
  }
}, [configString, form]);



const handleAddOutput = () => {
  const safePosition = findSafePosition(1, 'output', outputs.length);
  
const newOutput = {
  socketpin: "",
  type: "enabled",
  currentlimit: 10000,
  currentgreenlimit: 100,
  page: 1,
  row: safePosition.row,
  column: safePosition.column,
  icon: 1,
  nameTR: "Yeni Çıkış",
  nameGB: "New Output",
  nameDE: "Neuer Ausgang",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Nueva Salida",
    nameRU: "Новый выход",
    nameGR: "Νέα έξοδος",
    nameFR: "Nouvelle sortie",
    nameIT: "Nuova uscita",
    namePT: "Nova saída",
    nameSA: "مخرج جديد"
  }),
  cloneActive: false
};
  setOutputs([...outputs, newOutput]);
};

  const handleDeleteOutput = (index) => {
    const newOutputs = [...outputs];
    newOutputs.splice(index, 1);
    setOutputs(newOutputs);
  };

  const handleAddFloat = () => {
  const safePosition = findSafePosition(1, 'float', floats.length);
  
const newFloat = {
  socketpin: "",
  enable: "true",
  type: "",
  purpose: "",
  warn_percent: 20,
  error_percent: 0,
  lock_pin: "",
  page: 1,
  row: safePosition.row,
  column: safePosition.column,
  icon: 0,
  nameTR: "Temiz Su",
  nameGB: "Clean Water",
  nameDE: "Sauberes Wasser",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Agua Limpia",
    nameRU: "Чистая вода",
    nameGR: "Καθαρό νερό",
    nameFR: "Eau propre",
    nameIT: "Acqua pulita",
    namePT: "Água limpa",
    nameSA: "ماء نظيف"
  }),
  cloneActive: false
};
  setFloats([...floats, newFloat]);
};


  const [floats, setFloats] = useState([
    {
  socketpin: "B6",
  enable: "true",
  type: "0-190",
  purpose: "water",
  warn_percent: 20,
  error_percent: 0,
  lock_pin: "",
  page: 1,
  row: 1,
  column: 3,
  icon: 0,
  nameTR: "Temiz Su",
  nameGB: "Clean Water",
  nameDE: "Sauberes Wasser",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Agua Limpia",
    nameRU: "Чистая вода",
    nameGR: "Καθαρό νερό",
    nameFR: "Eau propre",
    nameIT: "Acqua pulita",
    namePT: "Água limpa",
    nameSA: "ماء نظيف"
  }),
  cloneActive: false,
},
    
  ]);

  const handleCloneFloat = (index) => {
  const updatedFloats = [...floats];
  if (!updatedFloats[index].cloneActive) {
    updatedFloats[index].cloneActive = true;
    
    const safePosition = findSafePosition(updatedFloats[index].page, 'float', index);
    updatedFloats[index].page2 = updatedFloats[index].page;
    updatedFloats[index].row2 = safePosition.row;
    updatedFloats[index].column2 = safePosition.column;
  }
  setFloats(updatedFloats);
};

  const validateRequiredPins = () => {
  const errors = [];
  
outputs.forEach((output, index) => {
    if (!output.socketpin || output.socketpin === "") {
      errors.push(translations[language].outputPinRequired.replace('{index}', index + 1));
    }
  });
  
  // Inputs kontrolü
  inputs.forEach((input, index) => {
    if (!input.socketpin || input.socketpin === "") {
      errors.push(translations[language].inputPinRequired.replace('{index}', index + 1));
    }
  });
  
  // Voltages kontrolü
  voltages.forEach((voltage, index) => {
    if (!voltage.socketpin || voltage.socketpin === "") {
      errors.push(translations[language].voltagePinRequired.replace('{index}', index + 1));
    }
  });
  
  // Floats kontrolü
  floats.forEach((float, index) => {
    if (!float.socketpin || float.socketpin === "") {
      errors.push(translations[language].floatPinRequired.replace('{index}', index + 1));
    }
  });
  
  return errors;
};

  const handleRemoveCloneFloat = (index) => {
    const updatedFloats = [...floats];
    if (updatedFloats[index].cloneActive) {
      updatedFloats[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedFloats[index].page2;
      delete updatedFloats[index].row2;
      delete updatedFloats[index].column2;
    }
    setFloats(updatedFloats);
  };

  const handleAddVoltage = () => {
  const safePosition = findSafePosition(1, 'voltage', voltages.length);
  
const newVoltage = {
  socketpin: "",
  enable: "true",
  page: 1,
  row: safePosition.row,
  column: safePosition.column,
  icon: 30,
  nameTR: "Servis Aküsü",
  nameGB: "Service Battery",
  nameDE: "Servicebatterie",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Batería de servicio",
    nameRU: "Сервисный аккумулятор",
    nameGR: "Μπαταρία υπηρεσίας",
    nameFR: "Batterie de service",
    nameIT: "Batteria di servizio",
    namePT: "Bateria de serviço",
    nameSA: "بطارية الخدمة"
  }),
  cloneActive: false
};
  setVoltages([...voltages, newVoltage]);
};

  const handleDeleteFloat =(index) => {
    const newFloats = [...floats];
    newFloats.splice(index,1);
    setFloats(newFloats);
  };

  const [voltages, setVoltages] = useState([
{
  socketpin: "00",
  enable: "true",
  page: 1,
  row: 1,
  column: 1,
  icon: 30,
  nameTR: "Servis Aküsü",
  nameGB: "Service Battery",
  nameDE: "Servicebatterie",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Batería de servicio",
    nameRU: "Сервисный аккумулятор",
    nameGR: "Μπαταρία υπηρεσίας",
    nameFR: "Batterie de service",
    nameIT: "Batteria di servizio",
    namePT: "Bateria de serviço",
    nameSA: "بطارية الخدمة"
  }),
  cloneActive: false,
}
  ]);

  const handleCloneVoltage = (index) => {
  const updatedVoltages = [...voltages];
  if (!updatedVoltages[index].cloneActive) {
    updatedVoltages[index].cloneActive = true;
    
    const safePosition = findSafePosition(updatedVoltages[index].page, 'voltage', index);
    updatedVoltages[index].page2 = updatedVoltages[index].page;
    updatedVoltages[index].row2 = safePosition.row;
    updatedVoltages[index].column2 = safePosition.column;
  }
  setVoltages(updatedVoltages);
};

  const handleRemoveCloneVoltage = (index) => {
    const updatedVoltages = [...voltages];
    if (updatedVoltages[index].cloneActive) {
      updatedVoltages[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedVoltages[index].page2;
      delete updatedVoltages[index].row2;
      delete updatedVoltages[index].column2;
    }
    setVoltages(updatedVoltages);
  };

  const handleDeleteVoltages =(index) => {
    const newVoltages = [...voltages];
    newVoltages.splice(index,1);
    setVoltages(newVoltages);
  };

  const handleAddRelay =() => {
    const newRelay ={
      enable: "true",
      short_circuit_socketpin: "C6",
      open_circuit_socketpin: "B8",
      short_circuit_voltage: 13200,
      open_circuit_voltage: 12500,
      manualoverride_duration: 75
    };
    setRelays([...relays, newRelay]);
  };

  const [relays, setRelays] = useState([
    {
      enable: "",
      short_circuit_socketpin: "",
      open_circuit_socketpin: "",
      short_circuit_voltage: 13200,
      open_circuit_voltage: 12500,
      manualoverride_duration: 75
    }
  ]);

  const handleAddSettings =() => {
    const newSetting ={
      force_shut_down_voltage: 10500,
      optional_down_voltage: 11000,
      start_warn_voltage: 11500,
      recover_voltage: 12000,
      force_shut_down_time: 60
    };
    setSettings([...settings, newSetting]);
  };

  const [settings, setSettings] = useState([
    {
      force_shut_down_voltage: 10500,
      optional_down_voltage: 11000,
      start_warn_voltage: 11500,
      recover_voltage: 12000,
      force_shut_down_time: 60
    }
  ]);

  const handleAddInput = () => {
  const safePosition = findSafePosition(1, 'input', inputs.length);
  
const newInput = {
  socketpin: "",
  enable: "true",
  vavienoutput: "",
  page: 1,
  row: safePosition.row,
  column: safePosition.column,
  icon: 6,
  nameTR: "Dış Aydınlatma",
  nameGB: "Outdoor Lighting",
  nameDE: "Außenbeleuchtung",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Iluminación exterior",
    nameRU: "Наружное освещение",
    nameGR: "Εξωτερικός φωτισμός",
    nameFR: "Éclairage extérieur",
    nameIT: "Illuminazione esterna",
    namePT: "Iluminação externa",
    nameSA: "إضاءة خارجية"
  }),
  cloneActive: false
};
  setInputs([...inputs, newInput]);
};

  const [inputs, setInputs] = useState([
{
  socketpin: "B4",
  enable: "true",
  vavienoutput: "",
  icon: 6,
  nameTR: "Dış Aydınlatma",
  nameGB: "Outdoor Lighting",
  nameDE: "Außenbeleuchtung",
  ...(selectedVersion !== "v2.08" && {
    nameES: "Iluminación exterior",
    nameRU: "Наружное освещение",
    nameGR: "Εξωτερικός φωτισμός",
    nameFR: "Éclairage extérieur",
    nameIT: "Illuminazione esterna",
    namePT: "Iluminação externa",
    nameSA: "إضاءة خارجية"
  }),
  cloneActive: false,
}
  ]);

  const getPageData = (pageNo) => {
  return pages.find(p => p.no === pageNo) || { first_row_capacity: 0, second_row_capacity: 0 };
};

// Kullanılan pozisyonları takip eden fonksiyon
const getUsedPositions = () => {
  const usedPositions = new Set();

  // Tüm itemların pozisyonlarını topla
  const allItems = [
    ...outputs.map(item => ({ ...item, type: 'output' })),
    ...inputs.map(item => ({ ...item, type: 'input' })),
    ...voltages.map(item => ({ ...item, type: 'voltage' })),
    ...floats.map(item => ({ ...item, type: 'float' }))
  ];

  allItems.forEach(item => {
    // Ana pozisyon kontrolü
    if (item.page && item.row && item.column) {
      usedPositions.add(`${item.page}-${item.row}-${item.column}`);
    }
    // Clone pozisyonlarını da kontrol et
    if (item.cloneActive && item.page2 && item.row2 && item.column2) {
      usedPositions.add(`${item.page2}-${item.row2}-${item.column2}`);
    }
  });

  return usedPositions;
};

const getDynamicRowOptions = (pageNo) => {
  const pageData = getPageData(pageNo);
  const options = [];
  
  if (pageData.first_row_capacity > 0) {
    options.push(1);
  }
  if (pageData.second_row_capacity > 0) {
    options.push(2);
  }
  
  return options;
};


const getDynamicColumnOptions = (pageNo, rowNo) => {
  const pageData = getPageData(pageNo) || {};
  let totalColumns = 0;
  
  if (rowNo === 1) {
    totalColumns = pageData.first_row_capacity || 0;
  } else if (rowNo === 2) {
    totalColumns = pageData.second_row_capacity || 0;
  }

  return Array.from({ length: totalColumns }, (_, i) => i + 1);
};

const getStateByType = (itemType) => {
  switch (itemType) {
    case 'output': return outputs;
    case 'input': return inputs;
    case 'voltage': return voltages;
    case 'float': return floats;
    default: return [];
  }
};

const getStateSetterByType = (itemType) => {
  switch (itemType) {
    case 'output': return setOutputs;
    case 'input': return setInputs;
    case 'voltage': return setVoltages;
    case 'float': return setFloats;
    default: return () => {};
  }
};

// Pozisyonun kullanılabilir olup olmadığını kontrol eden fonksiyon
const isPositionAvailable = (page, row, column, currentItemIndex, itemType, isClone = false) => {
  const usedPositions = getUsedPositions();
  const positionKey = `${page}-${row}-${column}`;
  
  // Eğer bu pozisyon kullanılmamışsa kullanılabilir
  if (!usedPositions.has(positionKey)) {
    return true;
  }

  // Mevcut item'ın kendi pozisyonuysa kullanılabilir
  let currentItems;
  switch (itemType) {
    case 'output':
      currentItems = outputs;
      break;
    case 'input':
      currentItems = inputs;
      break;
    case 'voltage':
      currentItems = voltages;
      break;
    case 'float':
      currentItems = floats;
      break;
    default:
      return false;
  }

  const currentItem = currentItems[currentItemIndex];
  
  // Normal pozisyon kontrolü
  if (!isClone && currentItem.page === page && currentItem.row === row && currentItem.column === column) {
    return true;
  }
  
  // Clone pozisyon kontrolü
  if (isClone && currentItem.page2 === page && currentItem.row2 === row && currentItem.column2 === column) {
    return true;
  }

  return false;
};

// Kullanılabilir kolon seçeneklerini getiren fonksiyon
const getAvailableColumnOptions = (pageNo, rowNo, currentItemIndex, itemType, isClone = false) => {
  const pageData = getPageData(pageNo);
  let totalColumns = 0;
  
  if (rowNo === 1) {
    totalColumns = pageData.first_row_capacity || 0;
  } else if (rowNo === 2) {
    totalColumns = pageData.second_row_capacity || 0;
  }

  if (totalColumns === 0) return [];

  const availableColumns = [];
  const usedPositions = getUsedPositions();
  
  for (let col = 1; col <= totalColumns; col++) {
    const positionKey = `${pageNo}-${rowNo}-${col}`;
    
    // Bu pozisyon kullanılmamış mı?
    if (!usedPositions.has(positionKey)) {
      availableColumns.push(col);
      continue;
    }

    // Mevcut item'ın kendi pozisyonu mu?
    const currentItems = getStateByType(itemType);
    const currentItem = currentItems[currentItemIndex];
    
    if (!currentItem) continue;

    // Ana pozisyon kontrolü
    if (!isClone && currentItem.page === pageNo && currentItem.row === rowNo && currentItem.column === col) {
      availableColumns.push(col);
    }
    
    // Clone pozisyon kontrolü
    if (isClone && currentItem.cloneActive && currentItem.page2 === pageNo && currentItem.row2 === rowNo && currentItem.column2 === col) {
      availableColumns.push(col);
    }
  }
  
  return availableColumns;
};

  const handleCloneInput = (index) => {
  const updatedInputs = [...inputs];
  if (!updatedInputs[index].cloneActive) {
    updatedInputs[index].cloneActive = true;
    
    const safePosition = findSafePosition(updatedInputs[index].page, 'input', index);
    updatedInputs[index].page2 = updatedInputs[index].page;
    updatedInputs[index].row2 = safePosition.row;
    updatedInputs[index].column2 = safePosition.column;
  }
  setInputs(updatedInputs);
};

const suggestCapacityReduction = (pageNo, rowNo, currentCapacity, targetCapacity) => {
  const affectedItems = [];
  const allItems = [
    ...outputs.map((item, index) => ({ ...item, type: 'output', index: index + 1 })),
    ...inputs.map((item, index) => ({ ...item, type: 'input', index: index + 1 })),
    ...voltages.map((item, index) => ({ ...item, type: 'voltage', index: index + 1 })),
    ...floats.map((item, index) => ({ ...item, type: 'float', index: index + 1 }))
  ];

  // Etkilenecek itemları bul
  allItems.forEach(item => {
    // Ana pozisyon kontrolü
    if (item.page === pageNo && item.row === rowNo && item.column > targetCapacity) {
      affectedItems.push({
        type: item.type,
        index: item.index,
        position: `Kolon ${item.column}`,
        isClone: false
      });
    }
    
    // Clone pozisyon kontrolü
    if (item.cloneActive && item.page2 === pageNo && item.row2 === rowNo && item.column2 > targetCapacity) {
      affectedItems.push({
        type: item.type,
        index: item.index,
        position: `Clone Kolon ${item.column2}`,
        isClone: true
      });
    }
  });

  if (affectedItems.length > 0) {
    console.log(`Sayfa ${pageNo} - ${rowNo === 1 ? '1. Sıra' : '2. Sıra'} kapasitesini ${targetCapacity}'e düşürmek için:`);
    console.log('Şu itemları taşımanız gerekiyor:');
    affectedItems.forEach(item => {
      console.log(`- ${item.type} ${item.index} (${item.position})`);
    });
  }

  return affectedItems;
};

const autoFixInvalidPositions = () => {
  const fixes = [];
  
  // Tüm itemları kontrol et ve geçersiz pozisyonları düzelt
  const allItemTypes = [
    { items: outputs, setter: setOutputs, type: 'output' },
    { items: inputs, setter: setInputs, type: 'input' },
    { items: voltages, setter: setVoltages, type: 'voltage' },
    { items: floats, setter: setFloats, type: 'float' }
  ];

  allItemTypes.forEach(({ items, setter, type }) => {
    const updatedItems = [...items];
    let hasChanges = false;

    updatedItems.forEach((item, index) => {
      const pageData = getPageData(item.page);
      
      // Ana pozisyon kontrolü
      const maxColumns = item.row === 1 ? pageData.first_row_capacity : pageData.second_row_capacity;
      if (item.column > maxColumns) {
        const safePosition = findSafePosition(item.page, type, index);
        updatedItems[index].row = safePosition.row;
        updatedItems[index].column = safePosition.column;
        fixes.push(`${type} ${index + 1} ana pozisyonu düzeltildi`);
        hasChanges = true;
      }

      // Clone pozisyon kontrolü
      if (item.cloneActive && item.page2 && item.row2 && item.column2) {
        const pageData2 = getPageData(item.page2);
        const maxColumns2 = item.row2 === 1 ? pageData2.first_row_capacity : pageData2.second_row_capacity;
        if (item.column2 > maxColumns2) {
          const safePosition2 = findSafePosition(item.page2, type, index);
          updatedItems[index].row2 = safePosition2.row;
          updatedItems[index].column2 = safePosition2.column;
          fixes.push(`${type} ${index + 1} clone pozisyonu düzeltildi`);
          hasChanges = true;
        }
      }
    });

    if (hasChanges) {
      setter(updatedItems);
    }
  });

  if (fixes.length > 0) {
    message.success(`${fixes.length} pozisyon otomatik olarak düzeltildi`, 4);
    console.log('Otomatik düzeltmeler:', fixes);
  }

  return fixes;
};

  const handleRemoveCloneInput = (index) => {
    const updatedInputs = [...inputs];
    if (updatedInputs[index].cloneActive) {
      updatedInputs[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedInputs[index].page2;
      delete updatedInputs[index].row2;
      delete updatedInputs[index].column2;
    }
    setInputs(updatedInputs);
  };

  const handleDeleteInput =(index) => {
    const newInputs = [...inputs];
    newInputs.splice(index,1);
    setInputs(newInputs);
  };

  const [pages, setPages] = useState([
    { no: 1, first_row_capacity: 4, second_row_capacity: 4, name: "-" },
    { no: 2, first_row_capacity: 4, second_row_capacity: 4, name: "-" },
    { no: 3, first_row_capacity: 4, second_row_capacity: 3, name: "-" }
  ]);
  
const handleChange = (index, field, value, setState, state, isPageField = false) => {
  if (field === 'page' && !isPageField) {
    const maxPage = pages.length;
    if (value > maxPage) {
      message.error(`Sayfa numarası maksimum sayfa sayısını aşamaz (${maxPage}).`);
      return;
    }
  }

  if (field === 'enable' && setState === setInputs) {
    const updatedState = [...state];
    updatedState[index][field] = value;
    
    // Eğer enable false yapılıyorsa pozisyon bilgilerini sıfırla
    if (value === "false") {
      updatedState[index].page = undefined;
      updatedState[index].row = undefined;
      updatedState[index].column = undefined;
      updatedState[index].cloneActive = false;
      delete updatedState[index].page2;
      delete updatedState[index].row2;
      delete updatedState[index].column2;
    } else {
      // Enable true yapılıyorsa güvenli pozisyon ata
      const safePosition = findSafePosition(1, 'input', index);
      updatedState[index].page = 1;
      updatedState[index].row = safePosition.row;
      updatedState[index].column = safePosition.column;
    }
    
    setState(updatedState);
    return;
  }

  // Sayfa kapasitesi değişikliği kontrolü
  if (isPageField && (field === 'first_row_capacity' || field === 'second_row_capacity')) {
    const pageNo = state[index].no;
    const rowNo = field === 'first_row_capacity' ? 1 : 2;
    const currentCapacity = state[index][field];
    
    // Kapasite azaltılıyorsa kontrol et
    if (value < currentCapacity) {
      const usedItems = checkIfPositionUsedInCapacity(pageNo, rowNo, value);
      
      if (usedItems.length > 0) {
        const itemsList = usedItems.join(', ');
        message.error(
          `Sayfa ${pageNo} - ${rowNo === 1 ? '1. Sıra' : '2. Sıra'} kapasitesi ${value}'e düşürülemiyor! ` +
          `Şu itemlar bu pozisyonlarda atanmış: ${itemsList}. ` +
          `Önce bu itemları başka pozisyonlara taşıyın veya silin.`,
          6 // 6 saniye göster
        );
        return; // Değişikliği engelle
      }
    }
  }

  // Değiştirilen alanın hata vurgusunu temizle
  if (!isPageField) {
    let itemType;
    if (setState === setOutputs) itemType = 'output';
    else if (setState === setInputs) itemType = 'input';
    else if (setState === setVoltages) itemType = 'voltage';
    else if (setState === setFloats) itemType = 'float';
    if (itemType) {
      const errorKey = `${itemType}_${index}_${field}`;
      setFieldErrors(prev => {
        if (!prev[errorKey]) return prev;
        const next = { ...prev };
        delete next[errorKey];
        return next;
      });
    }
  }

  // Değer çevirme
  let parsedValue;
  if (field === 'socketpin' && value === "00") {
    parsedValue = "00";
  } else if (/^\d+$/.test(value)) {
    parsedValue = parseInt(value, 10);
  } else {
    parsedValue = value;
  }

  const updatedState = [...state];
  updatedState[index] = { ...state[index] };

  if (field === 'page' && !isPageField) {
    updatedState[index][field] = parsedValue;
    
    // Item türünü belirle
    let itemType;
    if (setState === setOutputs) itemType = 'output';
    else if (setState === setInputs) itemType = 'input';
    else if (setState === setVoltages) itemType = 'voltage';
    else if (setState === setFloats) itemType = 'float';
    
    // Güvenli pozisyon bul
    const safePosition = findSafePosition(parsedValue, itemType, index);
    updatedState[index].row = safePosition.row;
    updatedState[index].column = safePosition.column;
    
    // Clone pozisyonları için de güvenli pozisyon bul
    if (updatedState[index].cloneActive) {
      const cloneSafePosition = findSafePosition(parsedValue, itemType, index);
      updatedState[index].page2 = parsedValue;
      updatedState[index].row2 = cloneSafePosition.row;
      updatedState[index].column2 = cloneSafePosition.column;
    }
  } 
  else if (field === 'row') {
    updatedState[index][field] = parsedValue;
    
    // Sıra değiştiğinde güvenli kolon bul
    const pageNo = updatedState[index].page;
    let itemType;
    if (setState === setOutputs) itemType = 'output';
    else if (setState === setInputs) itemType = 'input';
    else if (setState === setVoltages) itemType = 'voltage';
    else if (setState === setFloats) itemType = 'float';
    
    const columnOptions = getAvailableColumnOptions(pageNo, parsedValue, index, itemType, false);
    updatedState[index].column = columnOptions.length > 0 ? columnOptions[0] : undefined;
  } 
  else if (field === 'page2') {
    updatedState[index][field] = parsedValue;
    
    // Clone sayfa değiştiğinde güvenli pozisyon bul
    let itemType;
    if (setState === setOutputs) itemType = 'output';
    else if (setState === setInputs) itemType = 'input';
    else if (setState === setVoltages) itemType = 'voltage';
    else if (setState === setFloats) itemType = 'float';
    
    const safePosition = findSafePosition(parsedValue, itemType, index);
    updatedState[index].row2 = safePosition.row;
    updatedState[index].column2 = safePosition.column;
  }
  else if (field === 'row2') {
    updatedState[index][field] = parsedValue;
    
    // Clone sıra değiştiğinde güvenli kolon bul
    const pageNo = updatedState[index].page2;
    let itemType;
    if (setState === setOutputs) itemType = 'output';
    else if (setState === setInputs) itemType = 'input';
    else if (setState === setVoltages) itemType = 'voltage';
    else if (setState === setFloats) itemType = 'float';
    
    const columnOptions = getAvailableColumnOptions(pageNo, parsedValue, index, itemType, true);
    updatedState[index].column2 = columnOptions.length > 0 ? columnOptions[0] : undefined;
  }
  else {
    updatedState[index][field] = parsedValue;
  }
  
  setState(updatedState);
};
  
  const handleAddPage = () => {
    if (pages.length >= 10) {
      message.warning('Maksimum 10 sayfa eklenebilir.');
      return;
    }
    
    // Burada formdaki input değerlerini alıyoruz (örneğin state ile)
    const firstRowCapacity = formValues.first_row_capacity;
    const secondRowCapacity = formValues.second_row_capacity;
  
    const newPage = {
      no: pages.length + 1,
      first_row_capacity: firstRowCapacity,
      second_row_capacity: secondRowCapacity
    };
  
    setPages([...pages, newPage]);
  };
  

  const handleDeletePage = (index) => {
  const pageToDelete = pages[index];
  
  // Bu sayfada öğe var mı kontrol et
  if (checkIfPageHasItems(pageToDelete.no)) {
    message.error(`Sayfa ${pageToDelete.no} silinemez! Bu sayfada atanmış butonlar bulunuyor.`);
    return;
  }

  const newPages = [...pages];
  newPages.splice(index, 1);

  // Sayfa numaralarını güncelle
  const renumberedPages = newPages.map((page, idx) => ({
    ...page,
    no: idx + 1,
  }));

  // Silinen sayfadan büyük sayfa numaralarını güncelle
  const pageNoToDelete = pageToDelete.no;
  
  // Outputs güncelle
  const updatedOutputs = outputs.map(output => {
    const newOutput = { ...output };
    if (output.page > pageNoToDelete) {
      newOutput.page = output.page - 1;
    }
    if (output.cloneActive && output.page2 > pageNoToDelete) {
      newOutput.page2 = output.page2 - 1;
    }
    return newOutput;
  });

  // Inputs güncelle
  const updatedInputs = inputs.map(input => {
    const newInput = { ...input };
    if (input.page > pageNoToDelete) {
      newInput.page = input.page - 1;
    }
    if (input.cloneActive && input.page2 > pageNoToDelete) {
      newInput.page2 = input.page2 - 1;
    }
    return newInput;
  });

  // Voltages güncelle
  const updatedVoltages = voltages.map(voltage => {
    const newVoltage = { ...voltage };
    if (voltage.page > pageNoToDelete) {
      newVoltage.page = voltage.page - 1;
    }
    if (voltage.cloneActive && voltage.page2 > pageNoToDelete) {
      newVoltage.page2 = voltage.page2 - 1;
    }
    return newVoltage;
  });

  // Floats güncelle
  const updatedFloats = floats.map(float => {
    const newFloat = { ...float };
    if (float.page > pageNoToDelete) {
      newFloat.page = float.page - 1;
    }
    if (float.cloneActive && float.page2 > pageNoToDelete) {
      newFloat.page2 = float.page2 - 1;
    }
    return newFloat;
  });

  // State'leri güncelle
  setPages(renumberedPages);
  setOutputs(updatedOutputs);
  setInputs(updatedInputs);
  setVoltages(updatedVoltages);
  setFloats(updatedFloats);
};

// PanelPreview için wrapper fonksiyonlar
const handlePageSettingsChangeFromPreview = (updatedPage) => {
  const pageIndex = pages.findIndex(p => p.no === updatedPage.no);
  if (pageIndex !== -1) {
    const updatedPages = [...pages];
    updatedPages[pageIndex] = updatedPage;
    setPages(updatedPages);
  }
};

const handleAddPageFromPreview = () => {
  const firstRowCapacity = 4;
  const secondRowCapacity = 4;
  
  const newPage = {
    no: pages.length + 1,
    first_row_capacity: firstRowCapacity,
    second_row_capacity: secondRowCapacity,
    name: `Sayfa ${pages.length + 1}`
  };

  setPages([...pages, newPage]);
  message.success(`${translations[language].yenisayfaeklendi}`);
};

const handleDeletePageFromPreview = (pageNo) => {
  const pageIndex = pages.findIndex(p => p.no === pageNo);
  if (pageIndex !== -1) {
    handleDeletePage(pageIndex);
  }
};
  

  const translateText = async (text, from, to) => {
    // Çeviri API'sine istek at
    const response = await fetch(
      `https://api.mymemory.translated.net/get?q=${text}&langpair=${from}|${to}`
    );
    const data = await response.json();
    return data.responseData.translatedText;
  };

  const handleVoltageChangeForFloat = (index, field, value) => {
    setFloats((prev) => {
      const uptadeFloats = [...prev];
      uptadeFloats[index][field] = value;
      return uptadeFloats;
    });

    if (field === 'nameTR') {
      clearTimeout(floatDebounceRef.current);
      floatDebounceRef.current = setTimeout(() => {
        const promises = [
          translateText(value, 'tr', 'en'),
          translateText(value, 'tr', 'de'),
        ];
        if (selectedVersion !== "v2.08") {
          promises.push(
            translateText(value, 'tr', 'es'),
            translateText(value, 'tr', 'ru'),
            translateText(value, 'tr', 'el'),
            translateText(value, 'tr', 'fr'),
            translateText(value, 'tr', 'it'),
            translateText(value, 'tr', 'pt'),
            translateText(value, 'tr', 'ar'),
          );
        }
        Promise.all(promises).then((results) => {
          const [en, de, es, ru, gr, fr, it, pt, sa] = results;
          setFloats((prev) => {
            const updated = [...prev];
            updated[index].nameGB = en;
            updated[index].nameDE = de;
            if (selectedVersion !== "v2.08") {
              updated[index].nameES = es;
              updated[index].nameRU = ru;
              updated[index].nameGR = gr;
              updated[index].nameFR = fr;
              updated[index].nameIT = it;
              updated[index].namePT = pt;
              updated[index].nameSA = sa;
            }
            return updated;
          });
        });
      }, 1000);
    }
  };

  const handleVoltageChangeForInput = (index, field, value) => {
    setVoltages((prev) => {
      const updatedVoltages = [...prev];
      updatedVoltages[index][field] = value;
      return updatedVoltages;
    });

    if (field === 'nameTR') {
      clearTimeout(voltageDebounceRef.current);
      voltageDebounceRef.current = setTimeout(() => {
        const promises = [
          translateText(value, 'tr', 'en'),
          translateText(value, 'tr', 'de'),
        ];
        if (selectedVersion !== "v2.08") {
          promises.push(
            translateText(value, 'tr', 'es'),
            translateText(value, 'tr', 'ru'),
            translateText(value, 'tr', 'el'),
            translateText(value, 'tr', 'fr'),
            translateText(value, 'tr', 'it'),
            translateText(value, 'tr', 'pt'),
            translateText(value, 'tr', 'ar'),
          );
        }
        Promise.all(promises).then((results) => {
          const [en, de, es, ru, gr, fr, it, pt, sa] = results;
          setVoltages((prev) => {
            const updated = [...prev];
            updated[index].nameGB = en;
            updated[index].nameDE = de;
            if (selectedVersion !== "v2.08") {
              updated[index].nameES = es;
              updated[index].nameRU = ru;
              updated[index].nameGR = gr;
              updated[index].nameFR = fr;
              updated[index].nameIT = it;
              updated[index].namePT = pt;
              updated[index].nameSA = sa;
            }
            return updated;
          });
        });
      }, 1000);
    }
  };

  const handleInputChangeForInput = (index, field, value) => {
    setInputs((prev) => {
      const updatedInputs = [...prev];
      updatedInputs[index][field] = value;
      return updatedInputs;
    });

    if (field === 'nameTR') {
      clearTimeout(inputDebounceRef.current);
      inputDebounceRef.current = setTimeout(() => {
        const promises = [
          translateText(value, 'tr', 'en'),
          translateText(value, 'tr', 'de'),
        ];
        if (selectedVersion !== "v2.08") {
          promises.push(
            translateText(value, 'tr', 'es'),
            translateText(value, 'tr', 'ru'),
            translateText(value, 'tr', 'el'),
            translateText(value, 'tr', 'fr'),
            translateText(value, 'tr', 'it'),
            translateText(value, 'tr', 'pt'),
            translateText(value, 'tr', 'ar'),
          );
        }
        Promise.all(promises).then((results) => {
          const [en, de, es, ru, gr, fr, it, pt, sa] = results;
          setInputs((prev) => {
            const updated = [...prev];
            updated[index].nameGB = en;
            updated[index].nameDE = de;
            if (selectedVersion !== "v2.08") {
              updated[index].nameES = es;
              updated[index].nameRU = ru;
              updated[index].nameGR = gr;
              updated[index].nameFR = fr;
              updated[index].nameIT = it;
              updated[index].namePT = pt;
              updated[index].nameSA = sa;
            }
            return updated;
          });
        });
      }, 1000);
    }
  };

const handleInputChange = (index, field, value) => {
  setOutputs((prev) => {
    const updatedOutputs = [...prev];
    updatedOutputs[index][field] = value;
    return updatedOutputs;
  });

  if (field === 'nameTR') {
    clearTimeout(outputDebounceRef.current);
    outputDebounceRef.current = setTimeout(() => {
      const promises = [
        translateText(value, 'tr', 'en'),
        translateText(value, 'tr', 'de'),
      ];
      if (selectedVersion !== "v2.08") {
        promises.push(
          translateText(value, 'tr', 'es'),
          translateText(value, 'tr', 'ru'),
          translateText(value, 'tr', 'el'),
          translateText(value, 'tr', 'fr'),
          translateText(value, 'tr', 'it'),
          translateText(value, 'tr', 'pt'),
          translateText(value, 'tr', 'ar'),
        );
      }
      Promise.all(promises).then((results) => {
        const [en, de, es, ru, gr, fr, it, pt, sa] = results;
        setOutputs((prev) => {
          const updatedOutputs = [...prev];
          updatedOutputs[index].nameGB = en;
          updatedOutputs[index].nameDE = de;
          if (selectedVersion !== "v2.08") {
            updatedOutputs[index].nameES = es;
            updatedOutputs[index].nameRU = ru;
            updatedOutputs[index].nameGR = gr;
            updatedOutputs[index].nameFR = fr;
            updatedOutputs[index].nameIT = it;
            updatedOutputs[index].namePT = pt;
            updatedOutputs[index].nameSA = sa;
          }
          return updatedOutputs;
        });
      });
    }, 1000);
  }
};


let customerInputValues = {
  companyName: "TestCompany",
  caravanType: "TypeA",
  description: "Test açıklama",
  customerNameSurname: "Ahmet Yılmaz",
  customerPhone: "5551234567",
  customerCountry: "TR"
};

const userId = localStorage.getItem("userId");

const validatePositions = () => {
  const errors = [];
  
  // Outputs pozisyon kontrolü
  outputs.forEach((output, index) => {
    if (!output.page) {
      errors.push(translations[language].outputPageRequired.replace('{index}', index + 1));
    }
    if (!output.row) {
      errors.push(translations[language].outputRowRequired.replace('{index}', index + 1));
    }
    if (!output.column) {
      errors.push(translations[language].outputColumnRequired.replace('{index}', index + 1));
    }
    
    // Clone pozisyon kontrolü
    if (output.cloneActive) {
      if (!output.page2) {
        errors.push(translations[language].outputClonePageRequired.replace('{index}', index + 1));
      }
      if (!output.row2) {
        errors.push(translations[language].outputCloneRowRequired.replace('{index}', index + 1));
      }
      if (!output.column2) {
        errors.push(translations[language].outputCloneColumnRequired.replace('{index}', index + 1));
      }
    }
  });

  // Inputs pozisyon kontrolü
  inputs.forEach((input, index) => {
    if (input.enable === "true") {
      if (!input.page) {
        errors.push(translations[language].inputPageRequired.replace('{index}', index + 1));
      }
      if (!input.row) {
        errors.push(translations[language].inputRowRequired.replace('{index}', index + 1));
      }
      if (!input.column) {
        errors.push(translations[language].inputColumnRequired.replace('{index}', index + 1));
      }
      
      // Clone pozisyon kontrolü
      if (input.cloneActive) {
        if (!input.page2) {
          errors.push(translations[language].inputClonePageRequired.replace('{index}', index + 1));
        }
        if (!input.row2) {
          errors.push(translations[language].inputCloneRowRequired.replace('{index}', index + 1));
        }
        if (!input.column2) {
          errors.push(translations[language].inputCloneColumnRequired.replace('{index}', index + 1));
        }
      }
    }
  });

  // Voltages pozisyon kontrolü
  voltages.forEach((voltage, index) => {
    if (!voltage.page) {
      errors.push(translations[language].voltagePageRequired.replace('{index}', index + 1));
    }
    if (!voltage.row) {
      errors.push(translations[language].voltageRowRequired.replace('{index}', index + 1));
    }
    if (!voltage.column) {
      errors.push(translations[language].voltageColumnRequired.replace('{index}', index + 1));
    }
    
    // Clone pozisyon kontrolü
    if (voltage.cloneActive) {
      if (!voltage.page2) {
        errors.push(translations[language].voltageClonePageRequired.replace('{index}', index + 1));
      }
      if (!voltage.row2) {
        errors.push(translations[language].voltageCloneRowRequired.replace('{index}', index + 1));
      }
      if (!voltage.column2) {
        errors.push(translations[language].voltageCloneColumnRequired.replace('{index}', index + 1));
      }
    }
  });

  // Floats pozisyon kontrolü
  floats.forEach((float, index) => {
    if (!float.page) {
      errors.push(translations[language].floatPageRequired.replace('{index}', index + 1));
    }
    if (!float.row) {
      errors.push(translations[language].floatRowRequired.replace('{index}', index + 1));
    }
    if (!float.column) {
      errors.push(translations[language].floatColumnRequired.replace('{index}', index + 1));
    }
    
    // Clone pozisyon kontrolü
    if (float.cloneActive) {
      if (!float.page2) {
        errors.push(translations[language].floatClonePageRequired.replace('{index}', index + 1));
      }
      if (!float.row2) {
        errors.push(translations[language].floatCloneRowRequired.replace('{index}', index + 1));
      }
      if (!float.column2) {
        errors.push(translations[language].floatCloneColumnRequired.replace('{index}', index + 1));
      }
    }
  });

  return errors;
};


const handleSaveChanges = () => {
  if (!configName) {
    message.error(translations[language].configNameRequired);
    return;
  }

  // Tüm validation kontrollerini topla
  const allValidationErrors = [];

  // 1. Pin seçimi kontrolleri
  const pinErrors = validateRequiredPins();
  allValidationErrors.push(...pinErrors);

  const positionErrors = validatePositions();
  allValidationErrors.push(...positionErrors);

  // Validation kısmında relay kontrolünü şu şekilde güncelleyin:

// 6. Relays validation - sadece enable true ise kontrol et
const relaySocketPins = outputs
  .filter((output) => output.type === "relay")
  .map((output) => output.socketpin)
  .filter(pin => pin);

relays.forEach((relay, index) => {
  // Sadece enable true ise ve yeterli relay pin'i varsa validation yap
  if (relay.enable === "true" && relaySocketPins.length >= 2) {
    
    // Pin seçimi kontrolü
    if (!relay.short_circuit_socketpin || relay.short_circuit_socketpin === "") {
      allValidationErrors.push(translations[language].relayShortCircuitPinRequired.replace('{index}', index + 1));
    }
    
    if (!relay.open_circuit_socketpin || relay.open_circuit_socketpin === "") {
      allValidationErrors.push(translations[language].relayOpenCircuitPinRequired.replace('{index}', index + 1));
    }
    
    // Aynı pin seçilmiş mi kontrolü
    if (relay.short_circuit_socketpin === relay.open_circuit_socketpin) {
      allValidationErrors.push(translations[language].relayPinsDifferent.replace('{index}', index + 1));
    }
    
    // Voltage kontrolü
    if (relay.short_circuit_voltage < 0) {
      allValidationErrors.push(translations[language].relayShortCircuitVoltageNegative.replace('{index}', index + 1));
    }
    if (relay.open_circuit_voltage < 0) {
      allValidationErrors.push(translations[language].relayOpenCircuitVoltageNegative.replace('{index}', index + 1));
    }
    if (relay.manualoverride_duration < 0 || relay.manualoverride_duration > 86400) {
      allValidationErrors.push(translations[language].relayManualOverrideRange.replace('{index}', index + 1));
    }
  }
});

  // 2. Outputs validation
  outputs.forEach((output, index) => {
    // Pin kontrolü
    if (!output.socketpin || output.socketpin === "") {
      allValidationErrors.push(translations[language].outputPinRequired.replace('{index}', index + 1));
    }

    // Current limit kontrolü
    if (output.currentlimit < 0) {
      allValidationErrors.push(translations[language].outputCurrentLimitNegative.replace('{index}', index + 1));
    }

    // Current green limit kontrolü
    const currentLimitValue = output.currentlimit || 0;
  const currentGreenValue = output.currentgreenlimit || 0;
  
  // Her ikisi de aynı birimde (1000 ile çarpılmış)
  if (currentGreenValue > currentLimitValue) {
    const displayLimit = (currentLimitValue / 1000).toFixed(1);
    const displayGreen = (currentGreenValue / 1000).toFixed(1);
    allValidationErrors.push(
      translations[language].outputCurrentGreenExceedsLimit
        .replace('{index}', index + 1)
        .replace('{green}', displayGreen)
        .replace('{limit}', displayLimit)
    );
  }

    // Page kontrolü
    const maxPage = pages.length;
    if (output.page > maxPage) {
      allValidationErrors.push(
        translations[language].outputPageExceedsMax
          .replace('{index}', index + 1)
          .replace('{max}', maxPage)
      );
    }
  });

  // 3. Inputs validation
  inputs.forEach((input, index) => {
    if (!input.socketpin || input.socketpin === "") {
      allValidationErrors.push(translations[language].inputPinRequired.replace('{index}', index + 1));
    }
  });


  // 4. Voltages validation
  voltages.forEach((voltage, index) => {
    if (!voltage.socketpin || voltage.socketpin === "") {
      allValidationErrors.push(translations[language].voltagePinRequired.replace('{index}', index + 1));
    }
  });

  // 5. Floats validation
  floats.forEach((float, index) => {
    if (!float.socketpin || float.socketpin === "") {
      allValidationErrors.push(translations[language].floatPinRequired.replace('{index}', index + 1));
    }

    // Warn ve error percent kontrolü
    const warnValue = float.warn_percent ?? 0;
    const errorValue = float.error_percent ?? 0;
    const purpose = float.purpose;

    if (warnValue < 0) {
      allValidationErrors.push(translations[language].floatWarnPercentNegative.replace('{index}', index + 1));
    }

    if (errorValue < 0) {
      allValidationErrors.push(translations[language].floatErrorPercentNegative.replace('{index}', index + 1));
    }

    // Su için özel kontrol
    if (purpose === 'water' && warnValue <= errorValue) {
      allValidationErrors.push(translations[language].floatWaterWarnGreaterError.replace('{index}', index + 1));
    }

    // Atık su/gri su için özel kontrol
    if ((purpose === 'drain' || purpose === 'gray') && warnValue >= errorValue) {
      allValidationErrors.push(translations[language].floatDrainWarnLessError.replace('{index}', index + 1));
    }
  });

  // 6. Relays validation
  relays.forEach((relay, index) => {
    if (relay.enable === "true") {
      if (relay.short_circuit_voltage < 0) {
        allValidationErrors.push(translations[language].relayShortCircuitVoltageNegative.replace('{index}', index + 1));
      }
      if (relay.open_circuit_voltage < 0) {
        allValidationErrors.push(translations[language].relayOpenCircuitVoltageNegative.replace('{index}', index + 1));
      }
      if (relay.manualoverride_duration < 0 || relay.manualoverride_duration > 86400) {
        allValidationErrors.push(translations[language].relayManualOverrideRange.replace('{index}', index + 1));
      }
    }
  });

  // 7. Settings validation
  settings.forEach((setting, index) => {
    if (setting.force_shut_down_voltage < 0) {
      allValidationErrors.push(translations[language].settingForceShutDownVoltageNegative.replace('{index}', index + 1));
    }
    if (setting.optional_down_voltage < 0) {
      allValidationErrors.push(translations[language].settingOptionalDownVoltageNegative.replace('{index}', index + 1));
    }
    if (setting.start_warn_voltage < 0) {
      allValidationErrors.push(translations[language].settingStartWarnVoltageNegative.replace('{index}', index + 1));
    }
    if (setting.recover_voltage < 0) {
      allValidationErrors.push(translations[language].settingRecoverVoltageNegative.replace('{index}', index + 1));
    }
    if (setting.force_shut_down_time < 0 || setting.force_shut_down_time > 600) {
      allValidationErrors.push(translations[language].settingForceShutDownTimeRange.replace('{index}', index + 1));
    }
  });

  // 8. Pin çakışma kontrolleri
  const usedPins = new Map();

  // Output pinlerini kontrol et
  outputs.forEach((output, index) => {
    if (output.socketpin) {
      if (usedPins.has(output.socketpin)) {
        allValidationErrors.push(translations[language].pinDuplicate.replace('{pin}', output.socketpin));
      } else {
        usedPins.set(output.socketpin, `Output ${index + 1}`);
      }
    }
  });

  // Input pinlerini kontrol et
  inputs.forEach((input, index) => {
    if (input.socketpin) {
      if (usedPins.has(input.socketpin)) {
        allValidationErrors.push(translations[language].pinDuplicate.replace('{pin}', input.socketpin));
      } else {
        usedPins.set(input.socketpin, `Input ${index + 1}`);
      }
    }
  });

  // Voltage pinlerini kontrol et
  voltages.forEach((voltage, index) => {
    if (voltage.socketpin) {
      if (usedPins.has(voltage.socketpin)) {
        allValidationErrors.push(translations[language].pinDuplicate.replace('{pin}', voltage.socketpin));
      } else {
        usedPins.set(voltage.socketpin, `Voltage ${index + 1}`);
      }
    }
  });

  // Float pinlerini kontrol et
  floats.forEach((float, index) => {
    if (float.socketpin) {
      if (usedPins.has(float.socketpin)) {
        allValidationErrors.push(translations[language].pinDuplicate.replace('{pin}', float.socketpin));
      } else {
        usedPins.set(float.socketpin, `Float ${index + 1}`);
      }
    }
  });

  

  // EĞER HERHANGI BİR HATA VARSA KAYDETME İŞLEMİNİ DURDUR
  const usedPositions = new Map();
  const allItems = [
    ...outputs.map((item, index) => ({ ...item, type: 'output', index })),
    ...inputs.map((item, index) => ({ ...item, type: 'input', index })),
    ...voltages.map((item, index) => ({ ...item, type: 'voltage', index })),
    ...floats.map((item, index) => ({ ...item, type: 'float', index }))
  ];

  allItems.forEach(item => {
    // Ana pozisyon kontrolü
    if (item.page && item.row && item.column) {
      const positionKey = `${item.page}-${item.row}-${item.column}`;
      if (usedPositions.has(positionKey)) {
        allValidationErrors.push(
          translations[language].positionDuplicate
            .replace('{page}', item.page)
            .replace('{row}', item.row)
            .replace('{column}', item.column)
        );
      } else {
        usedPositions.set(positionKey, `${item.type} ${item.index + 1}`);
      }
    }

    // Clone pozisyon kontrolü
    if (item.cloneActive && item.page2 && item.row2 && item.column2) {
      const clonePositionKey = `${item.page2}-${item.row2}-${item.column2}`;
      if (usedPositions.has(clonePositionKey)) {
        allValidationErrors.push(
          translations[language].clonePositionDuplicate
            .replace('{page}', item.page2)
            .replace('{row}', item.row2)
            .replace('{column}', item.column2)
        );
      } else {
        usedPositions.set(clonePositionKey, `${item.type} ${item.index + 1} clone`);
      }
    }
  });

  // Alan hata haritası oluştur
  const newFieldErrors = {};
  outputs.forEach((output, i) => {
    if (!output.socketpin) newFieldErrors[`output_${i}_socketpin`] = true;
    if (!output.page) newFieldErrors[`output_${i}_page`] = true;
    if (!output.row) newFieldErrors[`output_${i}_row`] = true;
    if (!output.column) newFieldErrors[`output_${i}_column`] = true;
    if (output.cloneActive) {
      if (!output.page2) newFieldErrors[`output_${i}_page2`] = true;
      if (!output.row2) newFieldErrors[`output_${i}_row2`] = true;
      if (!output.column2) newFieldErrors[`output_${i}_column2`] = true;
    }
  });
  inputs.forEach((input, i) => {
    if (input.enable === "true") {
      if (!input.socketpin) newFieldErrors[`input_${i}_socketpin`] = true;
      if (!input.page) newFieldErrors[`input_${i}_page`] = true;
      if (!input.row) newFieldErrors[`input_${i}_row`] = true;
      if (!input.column) newFieldErrors[`input_${i}_column`] = true;
      if (input.cloneActive) {
        if (!input.page2) newFieldErrors[`input_${i}_page2`] = true;
        if (!input.row2) newFieldErrors[`input_${i}_row2`] = true;
        if (!input.column2) newFieldErrors[`input_${i}_column2`] = true;
      }
    }
  });
  voltages.forEach((voltage, i) => {
    if (!voltage.socketpin) newFieldErrors[`voltage_${i}_socketpin`] = true;
    if (!voltage.page) newFieldErrors[`voltage_${i}_page`] = true;
    if (!voltage.row) newFieldErrors[`voltage_${i}_row`] = true;
    if (!voltage.column) newFieldErrors[`voltage_${i}_column`] = true;
    if (voltage.cloneActive) {
      if (!voltage.page2) newFieldErrors[`voltage_${i}_page2`] = true;
      if (!voltage.row2) newFieldErrors[`voltage_${i}_row2`] = true;
      if (!voltage.column2) newFieldErrors[`voltage_${i}_column2`] = true;
    }
  });
  floats.forEach((float, i) => {
    if (!float.socketpin) newFieldErrors[`float_${i}_socketpin`] = true;
    if (!float.page) newFieldErrors[`float_${i}_page`] = true;
    if (!float.row) newFieldErrors[`float_${i}_row`] = true;
    if (!float.column) newFieldErrors[`float_${i}_column`] = true;
    if (float.cloneActive) {
      if (!float.page2) newFieldErrors[`float_${i}_page2`] = true;
      if (!float.row2) newFieldErrors[`float_${i}_row2`] = true;
      if (!float.column2) newFieldErrors[`float_${i}_column2`] = true;
    }
  });

  // EĞER HERHANGI BİR HATA VARSA KAYDETME İŞLEMİNİ DURDUR
  if (allValidationErrors.length > 0) {
    setFieldErrors(newFieldErrors);
    message.error(translations[language].saveStopped, 5);
    allValidationErrors.forEach(error => {
      message.error(error, 3);
    });
    console.log('Validation Hataları:', allValidationErrors);
    return; // İŞLEMİ DURDUR
  }
  setFieldErrors({});

  // Eğer buraya geldiysek, tüm validationlar geçti, kaydetme işlemine devam et
  try {
    const cleanedOutputs = outputs.map(output => {
      const { cloneActive, ...rest } = output;
      if (!cloneActive) {
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    const cleanedInputs = inputs.map(input => {
      const { cloneActive, ...rest } = input;
      
      // Enable false ise
      if (input.enable === "false") {
        // Sadece temel alanları tut
        const basicInput = {
          socketpin: input.socketpin,
          enable: "false"
        };
        
        // Eğer vavienoutput varsa VE BOŞ DEĞİLSE ekle
        if (input.vavienoutput && input.vavienoutput !== "") {
          basicInput.vavienoutput = input.vavienoutput;
          // Vavienoutput varsa diğer alanları da ekle
          basicInput.icon = input.icon;
          basicInput.nameTR = input.nameTR;
          basicInput.nameGB = input.nameGB;
          basicInput.nameDE = input.nameDE;
        }
        // vavienoutput boş ise hiç ekleme (otomatik olarak JSON'dan düşecek)
        
        return basicInput;
      }
      
      // Enable true ise
      if (!cloneActive) {
        const { page2, row2, column2, ...cleaned } = rest;
        // Vavienoutput boş ise sil
        if (!cleaned.vavienoutput || cleaned.vavienoutput === "") {
          delete cleaned.vavienoutput;
        }
        return cleaned;
      }
      
      // CloneActive true ise
      // Vavienoutput boş ise sil
      if (!rest.vavienoutput || rest.vavienoutput === "") {
        delete rest.vavienoutput;
      }
      return rest;
    });

    const cleanedVoltages = voltages.map(voltage => {
      const { cloneActive, ...rest } = voltage;
      if (!cloneActive) {
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    const cleanedFloats = floats.map(float => {
      const { cloneActive, ...rest } = float;
      if (!cloneActive) {
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    // Missing pins ekle
    const existingFloatPins = cleanedFloats.map(float => float.socketpin);
    const missingFloatPins = allFloatsPins.filter(pin => !existingFloatPins.includes(pin));
    const missingFloatData = missingFloatPins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const existingVoltagePins = cleanedVoltages.map(voltage => voltage.socketpin);
    const missingVoltagePins = allVoltagesPins.filter(pin => !existingVoltagePins.includes(pin));
    const missingVoltageData = missingVoltagePins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const existingInputPins = cleanedInputs.map(input => input.socketpin);
    const missingInputPins = allInputPins.filter(pin => !existingInputPins.includes(pin));
    const missingInputData = missingInputPins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const existingOutputPins = cleanedOutputs.map(output => output.socketpin);
    const missingOutputPins = allOutputPins.filter(pin => !existingOutputPins.includes(pin));
    const missingOutputData = missingOutputPins.map(pin => ({
      socketpin: pin,
      type: "disable"
    }));

    let relayData = null;
    
    const relaySocketPins = outputs
      .filter((output) => output.type === "relay")
      .map((output) => output.socketpin)
      .filter(pin => pin); // boş pinleri filtrele

    // Eğer en az 2 relay pin'i varsa ve enable true ise relay'i ekle
    if (relaySocketPins.length >= 2 && relays[0]?.enable === "true") {
      relayData = relays[0];
    } else {
      // Relay seçilmemişse veya enable false ise sadece enable: false gönder
      relayData = { enable: "false" };
    }

    const filteredPages = pages.map(({ name, ...rest }) => rest);

    const jsonData = {
      vehicle_name: vehicleName || '',
      outputs: [...cleanedOutputs, ...missingOutputData],
      pages: filteredPages,
      inputs: [...cleanedInputs, ...missingInputData],
      voltages: [...cleanedVoltages, ...missingVoltageData],
      floats: [...cleanedFloats, ...missingFloatData],
      settings: settings[0],
      relays: relayData,
      tempratures: tempratures
    };

    if (relayData) {
      jsonData.relays = relayData;
    }

    // JSON dosyasını indir
    const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'config.json';
    link.click();

    // API'ye gönder
    const userId = localStorage.getItem("userId");

    fetch("https://json-configrator-api.root.myoctoopidev.com/Customer/Create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        userId: userId,
        config: JSON.stringify(jsonData),
        configName: configName
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Başarılı:", data);
      message.success(translations[language].saveSuccess);
    })
    .catch(error => {
      console.error("Hata:", error);
      message.error(translations[language].saveError);
    });

  } catch (error) {
    console.error('Kaydetme hatası:', error);
    message.error(translations[language].unexpectedError);
  }
};

  const openCustomerModal = () => {
    setIsModalVisible(true);
  };

  // Modal form gönderildiğinde global değişkeni güncelle ve handleSaveChanges’i tetikle
  const handleModalOk = (values) => {
    // Modal ile gelen değerler boş bile olsa customerInputValues güncelleniyor.
    customerInputValues = { ...customerInputValues, ...values };
    setIsModalVisible(false);
    // Form gönderim işlemi sonrasında handleSaveChanges fonksiyonu çağrılıyor.
    handleSaveChanges();
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };
 
  const relaySocketPins = outputs
  .filter((output) => output.type === "relay")
  .map((output) => output.socketpin);

  const handleRelayChange = (index, field, value) => {
  const updatedRelays = [...relays];
  updatedRelays[index][field] = value;
  setRelays(updatedRelays);
};

  // outputs: state’ten gelen array
   const enabledPins = outputs
  .filter(o => o.type === 'enabled')
  .map(o => o.socketpin)
  .filter(pin => pin); // boş/undefined ise at

  return (
    <AppLayout>
          <ConfigProvider theme={isDarkMode ? darkTheme : undefined}>
          <div style={{display: 'flex',justifyContent: 'center',alignItems: 'flex-start',minHeight: '100vh',padding: '20px',}}>
          <div style={{ 
            display: 'flex', 
            width: '100%', 
            maxWidth: '1600px',
            gap: '24px'
          }}>
            <div style={{ 
          flex: '1', 
          minWidth: '600px',
          maxWidth: '50%', 
          height: '100vh', 
          padding: '8px', 
          fontSize: '10px',
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'none', // Firefox için
          msOverflowStyle: 'none', // IE/Edge için
          '&::-webkit-scrollbar': { // Chrome/Safari için
            display: 'none'
          }
        }}>
           <Card 
             title={
               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                 <span>{translations[language].layoutTitle}</span>
                 {localStorage.getItem("userVersion") && (
                   <Tag color="blue">{localStorage.getItem("userVersion")}</Tag>
                 )}
               </div>
             }
             bordered={false} 
             extra={

                <Input
                              value={vehicleName}
                             onChange={(e) => setVehicleName(e.target.value)}
                              placeholder={translations[language].AraçAdı}
                              style={{ width: '250px' }}
                            />
           
               
             }
           >

           
            <Form layout="vertical">
              <Collapse activeKey={activeCollapseKeys} 
  onChange={setActiveCollapseKeys}
  accordion={false}>
              {/* Pages Section */}
              {/* <Collapse.Panel header={`${translations[language].pages}`} key="2">
                  {pages.map((page, index) => (
                    <Card
                      key={index}
                      title={`${translations[language].pages} ${page.no}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeletePage(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button
                            type="link"
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
  <Col span={12}>
    <Form.Item label={<span>{translations[language].firstRowCapacity}<Tooltip title={translations[language].rowKapesite}> 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip></span> }>
      <Select
        value={page.first_row_capacity}
        onChange={(value) => handleChange(index, 'first_row_capacity', value, setPages, pages, true)}
        style={{ width: '100%' }}
      >
        {[0,1, 2, 3, 4, 5].map((val) => (
          <Select.Option key={val} value={val}>
            {val}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  </Col>
  <Col span={12}>
    <Form.Item label={<span>{translations[language].secondRowCapacity}<Tooltip title={translations[language].rowkapesite2}> 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip></span> }>
    <Select
      value={page.second_row_capacity}
      onChange={(value) =>
        handleChange(index, 'second_row_capacity', value, setPages, pages, true)
      }
      style={{ width: '100%' }}
    >
      {[ -1, 0, 1, 2, 3, 4, 5 ].map((val) => (
        <Select.Option key={val} value={val}>
          {val === -1 ? `${translations[language].empty}` : val}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
  </Col>
</Row>
<Row gutter={16}>
  <Col span={24}>
    <Form.Item label={<span>{translations[language].pageAlias}<Tooltip title={translations[language].benzersizIsim}> 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip></span> }>
      <Input
        value={page.name}
        onChange={(e) =>
          handleChange(index, 'name', e.target.value, setPages, pages, true)
        }
      />
    </Form.Item>
  </Col>
</Row>
                    </Card>
                  ))}
                  <Button type="dashed" onClick={handleAddPage}>
                  {translations[language].addPage}
                  </Button>
                </Collapse.Panel> */}


                {/* Outputs Section */}
                <Collapse.Panel header={`${translations[language].outputs}`} key="1">
  {outputs.map((output, index) => {
    
    // Dinamik seçenekleri hesapla
    const rowOptions = getDynamicRowOptions(output.page);
    const columnOptions = getAvailableColumnOptions(output.page, output.row, index, 'output', false);
    
    // Clone için dinamik seçenekler
    const cloneRowOptions = output.cloneActive ? getDynamicRowOptions(output.page2) : [];
    const cloneColumnOptions = output.cloneActive ? 
      getAvailableColumnOptions(output.page2, output.row2, index, 'output', true) : [];

    return(
      <Card
      id={`output-card-${index}`}
      ref={el => outputRefs.current[index] = el}
        key={index}
        title={`${translations[language].outputName} ${index + 1}`}
        bordered
        style={{ marginBottom: '20px', borderRadius: '8px' }}
        extra={
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                {/* Dimmer Checkbox */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <input
                    type="checkbox"
                    checked={output.dummy_dimmer ? true : false}
                    onChange={(e) => {
                      if (e.target.checked) {
                        handleChange(index, 'dummy_dimmer', { type: 'DIM', socketpin: 'A1' }, setOutputs, outputs);
                      } else {
                        // dummy_dimmer prop'unu tamamen sil
                        const updatedOutput = { ...outputs[index] };
                        delete updatedOutput.dummy_dimmer;
                        const newOutputs = [...outputs];
                        newOutputs[index] = updatedOutput;
                        setOutputs(newOutputs);
                      }
                    }}
                    style={{ transform: 'scale(1.2)' }}
                  />
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>Dimmer</span>
                  <Tooltip title={translations[language].bucıkısındimer}>
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff', fontSize: '12px' }} />
                  </Tooltip>
                </div>
          
                {/* Delete Button */}
                <Popconfirm 
                  title={translations[language].deleteConfirm} 
                  onConfirm={() => handleDeleteOutput(index)} 
                  okText={translations[language].yes} 
                  cancelText={translations[language].no}
                >
                  <Button
                    type="link"
                    danger
                    style={{
                      fontWeight: 'bold',
                      color: '#ff4d4f',
                      padding: '0 8px'
                    }}
                  >
                    {translations[language].delete}
                  </Button>
                </Popconfirm>
              </div>
        }
      >
        <Row gutter={16}>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].outputPin}
        <Tooltip title={translations[language].outputPinAcıklama}>
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
        </Tooltip>
      </span>
    } validateStatus={fieldErrors[`output_${index}_socketpin`] ? 'error' : ''}>
<Select
  value={output.socketpin}
  onChange={(value) => handleChange(index, 'socketpin', value, setOutputs, outputs)}
  status={fieldErrors[`output_${index}_socketpin`] ? 'error' : undefined}
>
  {(() => {
    // v2.12 ve üzerindeyse 32 pin, değilse 16 pin
    const allPins = selectedVersion !== "v2.08" && selectedVersion !== "v2.11" 
      ? ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "B1", "B8", "C6", "C7", "C8", "D0", "D1", "D2", "A1_2", "A2_2", "A3_2", "A4_2", "A5_2", "A6_2", "A7_2", "A8_2", "B1_2", "B8_2", "C6_2", "C7_2", "C8_2", "D0_2", "D1_2", "D2_2"]
      : ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "B1", "B8", "C6", "C7", "C8", "D0", "D1", "D2"];
    
    return allPins.map((pin) => {
      const isDisabled = outputs.some((o, oIndex) => o.socketpin === pin && oIndex !== index);
      return (
        <Select.Option key={pin} value={pin} disabled={isDisabled}>
          {pin}
        </Select.Option>
      );
    });
  })()}
</Select>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span> 
        {translations[language].type} 
        <Tooltip title={translations[language].röleAcıklama} > 
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
        </Tooltip> 
      </span>   
    }>
      <Select
        value={output.type}
        onChange={(value) => handleChange(index, 'type', value, setOutputs, outputs)}
      >
        <Select.Option value="disabled">{translations[language].disabled}</Select.Option>
        <Select.Option value="enabled">{translations[language].enabled}</Select.Option>
        <Select.Option value="fix">{translations[language].Fix}</Select.Option>
        <Select.Option value="relay">{translations[language].relay}</Select.Option>
      </Select>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item 
  label={
    <span>
      {translations[language].currentLimit} 
      <Tooltip title={translations[language].currenlimitacıklama}> 
        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
      </Tooltip>
    </span> 
  }
  name={`currentlimit_${index}`}
  rules={[
    {
      validator: (_, value) => {
        if (value < 0) {
          return Promise.reject(new Error('Negatif değer giremezsiniz'));
        }
        if (value > 15) {
          return Promise.reject(new Error('Maksimum değer 15 olabilir'));
        }
        return Promise.resolve();
      }
    }
  ]}
  getValueProps={(value) => ({ 
    value: value !== undefined ? value : (output.currentlimit ? output.currentlimit / 1000 : 10)
  })}
  getValueFromEvent={(value) => {
    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }
    return parseFloat(value) || 10;
  }}
>
      <InputNumber
    min={0}
    max={30}
    style={{ width: '100%' }}
    stringMode
    onChange={(value) => {
      if (typeof value === 'string') {
        value = value.replace(',', '.');
      }
      // State'e 1000 ile çarparak kaydet
      const newValue = parseFloat(value) * 1000;
      handleChange(index, 'currentlimit', newValue, setOutputs, outputs);
      // Form'u da güncelle
      form.setFieldValue(`currentlimit_${index}`, parseFloat(value));
    }}
    parser={(value) => value.replace(',', '.')}
  />
    </Form.Item>
  </Col>
</Row>

{/* Dinamik Pozisyon Seçimi */}
<Row gutter={16}>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].page}
        <Tooltip title={translations[language].outputSayfa}>
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
        </Tooltip>
      </span>
    } validateStatus={fieldErrors[`output_${index}_page`] ? 'error' : ''}>
      <Select
        value={output.page}
        onChange={(value) => handleChange(index, 'page', value, setOutputs, outputs)}
        style={{ width: '100%' }}
        status={fieldErrors[`output_${index}_page`] ? 'error' : undefined}
      >
        {pages.map((page) => (
          <Select.Option key={page.no} value={page.no}>
            {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].row}
        <Tooltip title={translations[language].outuptSatır}>
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
        </Tooltip>
      </span>
    } validateStatus={fieldErrors[`output_${index}_row`] ? 'error' : ''}>
      <Select
        value={output.row}
        onChange={(value) => handleChange(index, 'row', value, setOutputs, outputs)}
        style={{ width: '100%' }}
        disabled={!output.page}
        status={fieldErrors[`output_${index}_row`] ? 'error' : undefined}
      >
        {rowOptions.map(r => (
          <Select.Option key={r} value={r}>{r}</Select.Option>
        ))}
      </Select>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].column}
        <Tooltip title={translations[language].stunoutput}>
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
        </Tooltip>
      </span>
    } validateStatus={fieldErrors[`output_${index}_column`] ? 'error' : ''}>
      <Select
        value={output.column}
        onChange={(value) => handleChange(index, 'column', value, setOutputs, outputs)}
        style={{ width: '100%' }}
        disabled={!output.page || !output.row}
        status={fieldErrors[`output_${index}_column`] ? 'error' : undefined}
      >
        {columnOptions.map(c => (
          <Select.Option key={c} value={c}>{c}</Select.Option>
        ))}
      </Select>
    </Form.Item>  
  </Col>
  <Col span={24}>
    {output.cloneActive ? (
      <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneOutput(index)}>
        {translations[language].deleteClone}
      </Button>
    ) : (
      <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneOutput(index)}>
        {translations[language].clone}
      </Button>
    )}
  </Col>
</Row>

{/* Clone Pozisyon Seçimi */}
{output.cloneActive && (
  <Row 
    gutter={16} 
    style={{ 
      marginTop: '10px',
      border: '1px solid #d9d9d9',
      borderRadius: '6px',
      padding: '12px',
      backgroundColor: '#fafafa'
    }}
  >
    <Col span={8}>
      <Form.Item label={
        <span>
          {translations[language].page2}
          <Tooltip title={translations[language].klonlaoutpusayfa}>
            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
          </Tooltip>
        </span>
      } validateStatus={fieldErrors[`output_${index}_page2`] ? 'error' : ''}>
        <Select
          value={output.page2}
          onChange={(value) => handleChange(index, 'page2', value, setOutputs, outputs)}
          style={{ width: '100%' }}
          status={fieldErrors[`output_${index}_page2`] ? 'error' : undefined}
        >
          {pages.map((page) => (
            <Select.Option key={page.no} value={page.no}>
              {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label={
        <span>
          {translations[language].row2}
          <Tooltip title={translations[language].klonlarowoutput}>
            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
          </Tooltip>
        </span>
      } validateStatus={fieldErrors[`output_${index}_row2`] ? 'error' : ''}>
        <Select
          value={output.row2}
          onChange={(value) => handleChange(index, 'row2', value, setOutputs, outputs)}
          style={{ width: '100%' }}
          disabled={!output.page2}
          status={fieldErrors[`output_${index}_row2`] ? 'error' : undefined}
        >
          {cloneRowOptions.map(r => (
            <Select.Option key={r} value={r}>{r}</Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label={
        <span>
          {translations[language].column2}
          <Tooltip title={translations[language].klonlacolmoutputt}>
            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
          </Tooltip>
        </span>
      } validateStatus={fieldErrors[`output_${index}_column2`] ? 'error' : ''}>
        <Select
          value={output.column2}
          onChange={(value) => handleChange(index, 'column2', value, setOutputs, outputs)}
          style={{ width: '100%' }}
          disabled={!output.page2 || !output.row2}
          status={fieldErrors[`output_${index}_column2`] ? 'error' : undefined}
        >
          {cloneColumnOptions.map(c => (
            <Select.Option key={c} value={c}>{c}</Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  </Row>
)}

<Row gutter={16}>
  <Col span={8}>
    <Form.Item 
  label={
    <span>
      {translations[language].currentGreenLimit} 
      <Tooltip title={translations[language].akımlimitiaçıklama} > 
        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
      </Tooltip> 
    </span> 
  }
  name={`currentgreenlimit_${index}`}
  rules={[
    {
      validator: (_, value) => {
        if (value < 0) {
          return Promise.reject(new Error(translations[language].aylalg || 'Negatif değer giremezsiniz'));
        }
        
        // value burada form'daki değer (örn: 7)
        // currentlimit'i de form'dan alalım
        const currentLimitFormValue = form.getFieldValue(`currentlimit_${index}`);
        
        if (value > currentLimitFormValue) {
          return Promise.reject(new Error('Akım Yeşil Limiti, Akım Limitini geçemez!'));
        }
        
        return Promise.resolve();
      }
    }
  ]}
  getValueProps={(value) => ({ 
    value: value !== undefined ? value : (output.currentgreenlimit ? output.currentgreenlimit / 1000 : 9)
  })}
  getValueFromEvent={(value) => {
    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }
    return parseFloat(value) || 9;
  }}
>
  <InputNumber
    min={0}
    max={30}
    stringMode
    onChange={(value) => {
      if (typeof value === 'string') {
        value = value.replace(',', '.');
      }
      const parsedGreen = parseFloat(value) * 1000;
      const parsedLimit = output.currentlimit ?? 10000;

      if (parsedGreen > parsedLimit) {
        message.error('Akım Yeşil Limiti, Akım Limitini geçemez!');
      }

      handleChange(index, 'currentgreenlimit', parsedGreen, setOutputs, outputs);
    }}
    parser={(value) => value.replace(',', '.')}
    style={{ width: '100%' }}
  />
</Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].icon} 
        <Tooltip title={translations[language].ikonaçıklamaoutput} > 
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
        </Tooltip>
      </span> 
    }>
      <Button
        style={{ 
          width: '100%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '30px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white'
        }}
        onClick={() => {
          setCurrentOutputIndex(index);
          setIconModalVisible(true);
        }}
      >
        {icons[output.icon] && (
          <img
            src={icons[output.icon]}
            alt={`icon ${output.icon}`}
            style={{ 
              width: '20px', 
              height: '20px', 
              marginRight: '8px' 
            }}
          />
        )}
        {output.icon}
      </Button>
    </Form.Item>
  </Col>
</Row>

<Row gutter={16}>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].nameTR} 
        <Tooltip title={translations[language].açıklamatürkçe} > 
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
        </Tooltip>
      </span> 
    }>
      <Input
        value={output.nameTR}
        onChange={(e) => handleInputChange(index, 'nameTR', e.target.value)}
      />
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].nameGB}
        <Tooltip title={translations[language].açılamaIngülüzce}> 
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
        </Tooltip>
      </span> 
    }>
      <Input
        value={output.nameGB}
        onChange={(e) => handleInputChange(index, 'nameGB', e.target.value)}
      />
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label={
      <span>
        {translations[language].nameDE} 
        <Tooltip title={translations[language].açıklamaalmanca} > 
          <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
        </Tooltip> 
      </span> 
    }>
      <Input
        value={output.nameDE}
        onChange={(e) => handleInputChange(index, 'nameDE', e.target.value)}
      />
    </Form.Item>
  </Col>

</Row>

{selectedVersion !== "v2.08" && (
  <>
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item label="İspanyolca İsim (ES)">
          <Input 
            value={output.nameES}
            onChange={(e) => handleInputChange(index, 'nameES', e.target.value)}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="Rusça İsim (RU)">
          <Input 
            value={output.nameRU}
            onChange={(e) => handleInputChange(index, 'nameRU', e.target.value)}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="Yunanca İsim (GR)">
          <Input 
            value={output.nameGR}
            onChange={(e) => handleInputChange(index, 'nameGR', e.target.value)}
          />
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={16}>
      <Col span={8}>
        <Form.Item label="Fransızca İsim (FR)">
          <Input 
            value={output.nameFR}
            onChange={(e) => handleInputChange(index, 'nameFR', e.target.value)}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="İtalyanca İsim (IT)">
          <Input 
            value={output.nameIT}
            onChange={(e) => handleInputChange(index, 'nameIT', e.target.value)}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="Portekizce İsim (PT)">
          <Input 
            value={output.namePT}
            onChange={(e) => handleInputChange(index, 'namePT', e.target.value)}
          />
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={16}>
      <Col span={8}>
        <Form.Item label="Arapça İsim (SA)">
          <Input 
            value={output.nameSA}
            onChange={(e) => handleInputChange(index, 'nameSA', e.target.value)}
          />
        </Form.Item>
      </Col>
    </Row>
  </>
)}

{/* Dimmer seçiliyse seçenekleri göster */}
{output.dummy_dimmer && (
  <Row gutter={16} style={{ marginTop: '10px' }}>
    <Col span={8}>
      <Form.Item label={translations[language].dimmerType}>
        <Select
          value={output.dummy_dimmer.type || "DIM"}
          onChange={(value) => {
            const updatedDimmer = { ...output.dummy_dimmer, type: value };
            if (value === "RGB") {
              delete updatedDimmer.socketpin;
            } else if (!updatedDimmer.socketpin) {
              updatedDimmer.socketpin = "A1";
            }
            handleChange(index, 'dummy_dimmer', updatedDimmer, setOutputs, outputs);
          }}
        >
          <Select.Option value="DIM">DIM</Select.Option>
          <Select.Option value="RGB">RGB</Select.Option>
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label={translations[language].dimmertipi}>
        <Select
          value={output.dummy_dimmer.socketpin || ""}
          onChange={(value) => {
            const updatedDimmer = { ...output.dummy_dimmer, socketpin: value };
            handleChange(index, 'dummy_dimmer', updatedDimmer, setOutputs, outputs);
          }}
          disabled={output.dummy_dimmer.type === "RGB"}
        >
          <Select.Option value="A1">A1</Select.Option>
          <Select.Option value="A6">A6</Select.Option>
          <Select.Option value="A7">A7</Select.Option>
          <Select.Option value="A8">A8</Select.Option>
        </Select>
      </Form.Item>
    </Col>
  </Row>
)}

<Row gutter={16}>
</Row>
      </Card>
    );
  })}
<Button 
  id="add-output-button"
  type="dashed" 
  onClick={handleAddOutput} 
  style={{ 
    marginBottom: '20px',
    backgroundColor: selectedComponentType === 'output' ? '#ff9800' : 'transparent',
    borderColor: selectedComponentType === 'output' ? '#ff9800' : '#d9d9d9',
    borderWidth: selectedComponentType === 'output' ? '2px' : '1px',
    color: selectedComponentType === 'output' ? 'white' : 'inherit',
    fontWeight: selectedComponentType === 'output' ? 'bold' : 'normal',
    transition: 'all 0.3s ease'
  }}
>
  {translations[language].addOutput}
</Button>
</Collapse.Panel>

<Collapse.Panel header={`${translations[language].inputs}`} key="3">
  {inputs.map((input, index) => {
    
    // Dinamik seçenekleri hesapla
    const rowOptions = getDynamicRowOptions(input.page);
    const columnOptions = getAvailableColumnOptions(input.page, input.row, index, 'input', false);
    
    // Clone için dinamik seçenekler
    const cloneRowOptions = input.cloneActive ? getDynamicRowOptions(input.page2) : [];
    const cloneColumnOptions = input.cloneActive ? 
      getAvailableColumnOptions(input.page2, input.row2, index, 'input', true) : [];

    // Enable kontrolü - bu satırı ekleyin
    const isEnabled = input.enable === "true";

    return(
      <Card
        id={`input-card-${index}`}
        key={index}
        title={`${translations[language].inputName} ${index + 1}`}
        bordered
        style={{ marginBottom: '20px', borderRadius: '8px' }}
        extra={
          <Popconfirm
            title={translations[language].deleteConfirm}
            onConfirm={() => handleDeleteInput(index)}
            okText={translations[language].yes}
            cancelText={translations[language].no}
          >
            <Button 
              type="link" 
              danger
              style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
            >
              {translations[language].delete}
            </Button>
          </Popconfirm>
        }
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].inputPin}
                <Tooltip title={translations[language].inputpinaçıklama} >
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`input_${index}_socketpin`] ? 'error' : ''}>
<Select
  value={input.socketpin}
  onChange={(value) => handleChange(index, 'socketpin', value, setInputs, inputs)}
  status={fieldErrors[`input_${index}_socketpin`] ? 'error' : undefined}
>
  {(() => {
    // v2.12 ve üzerindeyse 8 pin, değilse 4 pin
    const allPins = selectedVersion !== "v2.08" && selectedVersion !== "v2.11" 
      ? ['B4', 'B3', 'B2', 'B5', 'B4_2', 'B3_2', 'B2_2', 'B5_2']
      : ['B4', 'B3', 'B2', 'B5'];
    
    return allPins.map((pin) => {
      const isDisabled = inputs.some((inp, inpIndex) => inp.socketpin === pin && inpIndex !== index);
      return (
        <Select.Option key={pin} value={pin} disabled={isDisabled}>
          {pin}
        </Select.Option>
      );
    });
  })()}
</Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].enable} 
                <Tooltip title={translations[language].enableaçıklama} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Select
                value={input.enable}
                onChange={(value) => handleChange(index, 'enable', value, setInputs, inputs)}
                style={{ width: '100%' }}
              >
                <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                <Select.Option value={"false"}>{translations[language].no}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
  <Form.Item label={
    <span>
      {translations[language].vavienOutput}
      <Tooltip title={translations[language].vaivenaçıklama}> 
        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
      </Tooltip>
    </span> 
  }>
    <Select
      value={input.vavienoutput}
      onChange={(value) => handleChange(index, 'vavienoutput', value, setInputs, inputs)}
      style={{ width: '100%' }}
      allowClear  // Temizleme butonu ekler
      placeholder={translations[language].selectVavienOutput || "Seçiniz"}
    >
      {/* BOŞ SEÇENEĞİ EKLE */}
<Select.Option value="">{translations[language].empty || "Boş"}</Select.Option>

{outputs
  .filter(output => output.socketpin && !output.socketpin.endsWith('_2'))
  .map(output => output.socketpin)
  .map((pin) => (
    <Select.Option 
      key={pin} 
      value={pin} 
    >
      {pin}
    </Select.Option>
  ))}
</Select>
  </Form.Item>
</Col>
        </Row>

        {/* Dinamik Pozisyon Seçimi - SADECE ENABLE TRUE İSE GÖSTER */}
        {isEnabled && (
          <>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].page}
                    <Tooltip title={translations[language].inğutpageaçıklama}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                } validateStatus={fieldErrors[`input_${index}_page`] ? 'error' : ''}>
                  <Select
                    value={input.page}
                    onChange={(value) => handleChange(index, 'page', value, setInputs, inputs)}
                    style={{ width: '100%' }}
                    status={fieldErrors[`input_${index}_page`] ? 'error' : undefined}
                  >
                    {pages.map((page) => (
                      <Select.Option key={page.no} value={page.no}>
                        {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].row}
                    <Tooltip title={translations[language].girişinsıranu}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                } validateStatus={fieldErrors[`input_${index}_row`] ? 'error' : ''}>
                  <Select
                    value={input.row}
                    onChange={(value) => handleChange(index, 'row', value, setInputs, inputs)}
                    style={{ width: '100%' }}
                    disabled={!input.page}
                    status={fieldErrors[`input_${index}_row`] ? 'error' : undefined}
                  >
                    {rowOptions.map(r => (
                      <Select.Option key={r} value={r}>{r}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].column}
                    <Tooltip title={translations[language].girişinkolonnumarası}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                } validateStatus={fieldErrors[`input_${index}_column`] ? 'error' : ''}>
                  <Select
                    value={input.column}
                    onChange={(value) => handleChange(index, 'column', value, setInputs, inputs)}
                    style={{ width: '100%' }}
                    disabled={!input.page || !input.row}
                    status={fieldErrors[`input_${index}_column`] ? 'error' : undefined}
                  >
                    {columnOptions.map(c => (
                      <Select.Option key={c} value={c}>{c}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                {input.cloneActive ? (
                  <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneInput(index)}>
                    {translations[language].deleteClone}
                  </Button>
                ) : (
                  <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneInput(index)}>
                    {translations[language].clone}
                  </Button>
                )}
              </Col>
            </Row>

            {/* Clone Pozisyon Seçimi */}
            {input.cloneActive && (
              <Row gutter={16} style={{ 
                marginTop: '10px',
                border: '1px solid #d9d9d9',
                borderRadius: '6px',
                padding: '12px',
                backgroundColor: '#fafafa'
              }}>
                <Col span={8}>
                  <Form.Item label={
                    <span>
                      {translations[language].page2}
                      <Tooltip title={translations[language].klonlasayfa}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip>
                    </span> 
                  }>
                    <Select
                      value={input.page2}
                      onChange={(value) => handleChange(index, 'page2', value, setInputs, inputs)}
                      style={{ width: '100%' }}
                    >
                      {pages.map((page) => (
                        <Select.Option key={page.no} value={page.no}>
                          {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={
                    <span>
                      {translations[language].row2}
                      <Tooltip title={translations[language].klonlasıranumarası}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip>
                    </span> 
                  }>
                    <Select
                      value={input.row2}
                      onChange={(value) => handleChange(index, 'row2', value, setInputs, inputs)}
                      style={{ width: '100%' }}
                      disabled={!input.page2}
                    >
                      {cloneRowOptions.map(r => (
                        <Select.Option key={r} value={r}>{r}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={
                    <span>
                      {translations[language].column2}
                      <Tooltip title={translations[language].klonladasırakolonnumarası}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip>
                    </span> 
                  }>
                    <Select
                      value={input.column2}
                      onChange={(value) => handleChange(index, 'column2', value, setInputs, inputs)}
                      style={{ width: '100%' }}
                      disabled={!input.page2 || !input.row2}
                    >
                      {cloneColumnOptions.map(c => (
                        <Select.Option key={c} value={c}>{c}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].icon} 
                    <Tooltip title={translations[language].İkonaçıklama} > 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip>
                  </span> 
                }>
                  <Button
                    style={{ 
                      width: '100%', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      height: '30px',
                      backgroundColor: '#1890ff',
                      borderColor: '#1890ff',
                      color: 'white'
                    }}
                    onClick={() => {
                      setCurrentInputIndex(index);
                      setIconModalVisible(true);
                    }}
                  >
                    {icons[input.icon] && (
                      <img
                        src={icons[input.icon]}
                        alt={`icon ${input.icon}`}
                        style={{ 
                          width: '20px', 
                          height: '20px', 
                          marginRight: '8px' 
                        }}
                      />
                    )}
                    {input.icon}
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].nameTR}
                    <Tooltip title={translations[language].açıklamatürkçe}> 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip>
                  </span> 
                }>
                  <Input
                    value={input.nameTR}
                    onChange={(e) => handleInputChangeForInput(index, 'nameTR', e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].nameGB}
                    <Tooltip title={translations[language].açılamaIngülüzce}> 
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip>
                  </span> 
                }>
                  <Input
                    value={input.nameGB}
                    onChange={(e) => handleInputChangeForInput(index, 'nameGB', e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={
                  <span>
                    {translations[language].nameDE}
                    <Tooltip title={translations[language].açıklamaalmanca}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                    </Tooltip>
                  </span> 
                }>
                  <Input
                    value={input.nameDE}
                    onChange={(e) => handleInputChangeForInput(index, 'nameDE', e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
                        {selectedVersion !== "v2.08" && (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="İspanyolca İsim (ES)">
                      <Input 
                        value={input.nameES}
                        onChange={(e) => handleChange(index, 'nameES', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Rusça İsim (RU)">
                      <Input 
                        value={input.nameRU}
                        onChange={(e) => handleChange(index, 'nameRU', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Yunanca İsim (GR)">
                      <Input 
                        value={input.nameGR}
                        onChange={(e) => handleChange(index, 'nameGR', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
            
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="Fransızca İsim (FR)">
                      <Input 
                        value={input.nameFR}
                        onChange={(e) => handleChange(index, 'nameFR', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="İtalyanca İsim (IT)">
                      <Input 
                        value={input.nameIT}
                        onChange={(e) => handleChange(index, 'nameIT', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Portekizce İsim (PT)">
                      <Input 
                        value={input.namePT}
                        onChange={(e) => handleChange(index, 'namePT', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
            
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="Arapça İsim (SA)">
                      <Input 
                        value={input.nameSA}
                        onChange={(e) => handleChange(index, 'nameSA', e.target.value, setInputs, inputs)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Card>
    );
  })}
  <Button 
  id="add-input-button"
  type="dashed" 
  onClick={handleAddInput} 
  style={{ 
    marginBottom: '20px',
    backgroundColor: selectedComponentType === 'input' ? '#ff9800' : 'transparent',
    borderColor: selectedComponentType === 'input' ? '#ff9800' : '#d9d9d9',
    borderWidth: selectedComponentType === 'input' ? '2px' : '1px',
    color: selectedComponentType === 'input' ? 'white' : 'inherit',
    fontWeight: selectedComponentType === 'input' ? 'bold' : 'normal',
    transition: 'all 0.3s ease'
  }}
>
  {translations[language].addInput}
</Button>
</Collapse.Panel>
                  {/* Voltage Section */}
                  <Collapse.Panel header={`${translations[language].voltages}`} key="4">
  {voltages.map((voltage, index) => {
    
    // Dinamik seçenekleri hesapla
    const rowOptions = getDynamicRowOptions(voltage.page);
    const columnOptions = getAvailableColumnOptions(voltage.page, voltage.row, index, 'voltage', false);
    
    // Clone için dinamik seçenekler
    const cloneRowOptions = voltage.cloneActive ? getDynamicRowOptions(voltage.page2) : [];
    const cloneColumnOptions = voltage.cloneActive ? 
      getAvailableColumnOptions(voltage.page2, voltage.row2, index, 'voltage', true) : [];

    return(
      <Card
      id={`voltage-card-${index}`}
        key={index}
        title={`${translations[language].voltageName} ${index + 1}`}
        bordered
        style={{ marginBottom: '20px', borderRadius: '8px' }}
        extra={
          <Popconfirm
            title={translations[language].deleteConfirm}
            onConfirm={() => handleDeleteVoltages(index)}
            okText={translations[language].yes}
            cancelText={translations[language].no}
          >
            <Button 
              type="link" 
              danger
              style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
            >
              {translations[language].delete}
            </Button>
          </Popconfirm>
        }
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].voltagesPin}
                <Tooltip title={translations[language].voltagepinaçıklama}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`voltage_${index}_socketpin`] ? 'error' : ''}>
<Select
  value={voltage.socketpin}
  onChange={(value) => handleChange(index, 'socketpin', value, setVoltages, voltages)}
  style={{ width: '100%' }}
  status={fieldErrors[`voltage_${index}_socketpin`] ? 'error' : undefined}
>
  {(() => {
    // v2.12 ve üzerindeyse 10 pin, değilse 5 pin
    const allPins = selectedVersion !== "v2.08" && selectedVersion !== "v2.11" 
      ? ['00', 'C1', 'C2', 'C3', 'C4', 'C1_2', 'C2_2', 'C3_2', 'C4_2']
      : ['00', 'C1', 'C2', 'C3', 'C4'];
    
    return allPins.map((pin) => {
      const isDisabled = voltages.some((vol, volIndex) => vol.socketpin === pin && volIndex !== index);
      return (
        <Select.Option key={pin} value={pin} disabled={isDisabled}>
          {pin}
        </Select.Option>
      );
    });
  })()}
</Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].enable}
                <Tooltip title={translations[language].voltagenableaçıklama}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Select
                value={voltage.enable}
                onChange={(value) => handleChange(index, 'enable', value, setVoltages, voltages)}
                style={{ width: '100%' }}
              >
                <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                <Select.Option value={"false"}>{translations[language].no}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Dinamik Pozisyon Seçimi */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].page}
                <Tooltip title={translations[language].pagevoltajaçıklama} >
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`voltage_${index}_page`] ? 'error' : ''}>
              <Select
                value={voltage.page}
                onChange={(value) => handleChange(index, 'page', value, setVoltages, voltages)}
                style={{ width: '100%' }}
                status={fieldErrors[`voltage_${index}_page`] ? 'error' : undefined}
              >
                {pages.map((page) => (
                  <Select.Option key={page.no} value={page.no}>
                    {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].row}
                <Tooltip title={translations[language].voltajaçıklamaymış}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`voltage_${index}_row`] ? 'error' : ''}>
              <Select
                value={voltage.row}
                onChange={(value) => handleChange(index, 'row', value, setVoltages, voltages)}
                style={{ width: '100%' }}
                disabled={!voltage.page}
                status={fieldErrors[`voltage_${index}_row`] ? 'error' : undefined}
              >
                {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].column}
                <Tooltip title={translations[language].voltajsensörükolonnum} >
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`voltage_${index}_column`] ? 'error' : ''}>
              <Select
                value={voltage.column}
                onChange={(value) => handleChange(index, 'column', value, setVoltages, voltages)}
                style={{ width: '100%' }}
                disabled={!voltage.page || !voltage.row}
                status={fieldErrors[`voltage_${index}_column`] ? 'error' : undefined}
              >
                {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            {voltage.cloneActive ? (
              <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneVoltage(index)}>
                {translations[language].deleteClone}
              </Button>
            ) : (
              <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneVoltage(index)}>
                {translations[language].clone}
              </Button>
            )}
          </Col>
        </Row>

        {/* Clone Pozisyon Seçimi */}
        {voltage.cloneActive && (
          <Row gutter={16} style={{ 
            marginTop: '10px',
            border: '1px solid #d9d9d9',
            borderRadius: '6px', 
            padding: '12px',
            backgroundColor: '#fafafa'
          }}>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].page2}
                  <Tooltip title={translations[language].klonlasayfa}> 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip>
                </span> 
              }>
                <Select
                  value={voltage.page2}
                  onChange={(value) => handleChange(index, 'page2', value, setVoltages, voltages)}
                  style={{ width: '100%' }}
                >
                  {pages.map((page) => (
                    <Select.Option key={page.no} value={page.no}>
                      {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].row2}
                  <Tooltip title={translations[language].klonlasıranumarası}> 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip>
                </span> 
              }>
                <Select
                  value={voltage.row2}
                  onChange={(value) => handleChange(index, 'row2', value, setVoltages, voltages)}
                  style={{ width: '100%' }}
                  disabled={!voltage.page2}
                >
                  {cloneRowOptions.map(r => (
                    <Select.Option key={r} value={r}>{r}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].column2}
                  <Tooltip title={translations[language].klonladasırakolonnumarası}> 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip>
                </span> 
              }>
                <Select
                  value={voltage.column2}
                  onChange={(value) => handleChange(index, 'column2', value, setVoltages, voltages)}
                  style={{ width: '100%' }}
                  disabled={!voltage.page2 || !voltage.row2}
                >
                  {cloneColumnOptions.map(c => (
                    <Select.Option key={c} value={c}>{c}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].icon}
                <Tooltip title={translations[language].İkonaçıklama}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Button
                style={{ 
                  width: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  height: '30px',
                  backgroundColor: '#1890ff',
                  borderColor: '#1890ff',
                  color: 'white'
                }}
                onClick={() => {
                  setCurrentVoltageIndex(index);
                  setIconModalVisible(true);
                }}
              >
                {icons[voltage.icon] && (
                  <img
                    src={icons[voltage.icon]}
                    alt={`icon ${voltage.icon}`}
                    style={{ 
                      width: '20px', 
                      height: '20px', 
                      marginRight: '8px' 
                    }}
                  />
                )}
                {voltage.icon}
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameTR} 
                <Tooltip title={translations[language].açıklamatürkçe} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={voltage.nameTR}
                onChange={(e) => handleVoltageChangeForInput(index, 'nameTR', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameGB} 
                <Tooltip title={translations[language].açılamaIngülüzce} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={voltage.nameGB}
                onChange={(e) => handleVoltageChangeForInput(index, 'nameGB', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameDE} 
                <Tooltip title={translations[language].açıklamaalmanca}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={voltage.nameDE}
                onChange={(e) => handleVoltageChangeForInput(index, 'nameDE', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>

                {selectedVersion !== "v2.08" && (
          <>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="İspanyolca İsim (ES)">
                  <Input 
                    value={voltage.nameES}
                    onChange={(e) => handleChange(index, 'nameES', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Rusça İsim (RU)">
                  <Input 
                    value={voltage.nameRU}
                    onChange={(e) => handleChange(index, 'nameRU', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Yunanca İsim (GR)">
                  <Input 
                    value={voltage.nameGR}
                    onChange={(e) => handleChange(index, 'nameGR', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
            </Row>
        
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Fransızca İsim (FR)">
                  <Input 
                    value={voltage.nameFR}
                    onChange={(e) => handleChange(index, 'nameFR', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="İtalyanca İsim (IT)">
                  <Input 
                    value={voltage.nameIT}
                    onChange={(e) => handleChange(index, 'nameIT', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Portekizce İsim (PT)">
                  <Input 
                    value={voltage.namePT}
                    onChange={(e) => handleChange(index, 'namePT', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
            </Row>
        
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Arapça İsim (SA)">
                  <Input 
                    value={voltage.nameSA}
                    onChange={(e) => handleChange(index, 'nameSA', e.target.value, setVoltages, voltages)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Card>
    );
  })}
  <Button 
  id="add-voltage-button"
  type="dashed" 
  onClick={handleAddVoltage} 
  style={{ 
    marginBottom: '20px',
    backgroundColor: selectedComponentType === 'voltage' ? '#ff9800' : 'transparent',
    borderColor: selectedComponentType === 'voltage' ? '#ff9800' : '#d9d9d9',
    borderWidth: selectedComponentType === 'voltage' ? '2px' : '1px',
    color: selectedComponentType === 'voltage' ? 'white' : 'inherit',
    fontWeight: selectedComponentType === 'voltage' ? 'bold' : 'normal',
    transition: 'all 0.3s ease'
  }}
>
  {translations[language].addVoltage}
</Button>
</Collapse.Panel>
                  {/* floats Section */}
                  <Collapse.Panel header={`${translations[language].floats}`} key="5">
  {floats.map((float, index) => {
    
    // Dinamik seçenekleri hesapla
    const rowOptions = getDynamicRowOptions(float.page);
    const columnOptions = getAvailableColumnOptions(float.page, float.row, index, 'float', false);
    
    // Clone için dinamik seçenekler
    const cloneRowOptions = float.cloneActive ? getDynamicRowOptions(float.page2) : [];
    const cloneColumnOptions = float.cloneActive ? 
      getAvailableColumnOptions(float.page2, float.row2, index, 'float', true) : [];

    return(
      <Card
      id={`float-card-${index}`}
        key={index}
        title={`${translations[language].floatName} ${index + 1}`}
        bordered
        style={{ marginBottom: '20px', borderRadius: '8px' }}
        extra={
          <Popconfirm
            title={translations[language].deleteConfirm}
            onConfirm={() => handleDeleteFloat(index)}
            okText={translations[language].yes}
            cancelText={translations[language].no}
          >
            <Button 
              type="link" 
              danger
              style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
            >
              {translations[language].delete}
            </Button>
          </Popconfirm>
        }
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].floatsPin}
                <Tooltip title={translations[language].şamandırapinaçıklama}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`float_${index}_socketpin`] ? 'error' : ''}>
<Select
  value={float.socketpin}
  onChange={(value) => handleChange(index, 'socketpin', value, setFloats, floats)}
  style={{ width: '100%' }}
  status={fieldErrors[`float_${index}_socketpin`] ? 'error' : undefined}
>
  {(() => {
    // v2.12 ve üzerindeyse 10 pin, değilse 5 pin
    const allPins = selectedVersion !== "v2.08" && selectedVersion !== "v2.11" 
      ? ['B6', 'B7', 'C1', 'C2', 'C3', 'B6_2', 'B7_2', 'C1_2', 'C2_2', 'C3_2']
      : ['B6', 'B7', 'C1', 'C2', 'C3'];
    
    return allPins.map((pin) => {
      // C1, C2, C3 ve C1_2, C2_2, C3_2 için özel kontrol
      const isC123Pin = ['C1', 'C2', 'C3'].includes(pin);
      const isC123_2Pin = ['C1_2', 'C2_2', 'C3_2'].includes(pin);
      
      const isC123Used = isC123Pin && floats.some((flt, fltIndex) => 
        ['C1', 'C2', 'C3'].includes(flt.socketpin) && 
        fltIndex !== index
      );
      
      const isC123_2Used = isC123_2Pin && floats.some((flt, fltIndex) => 
        ['C1_2', 'C2_2', 'C3_2'].includes(flt.socketpin) && 
        fltIndex !== index
      );
      
      // Diğer pinler için normal kontrol
      const isNormalPinUsed = floats.some((flt, fltIndex) => 
        flt.socketpin === pin && 
        fltIndex !== index
      );
      
      const isDisabled = isC123Pin ? isC123Used : (isC123_2Pin ? isC123_2Used : isNormalPinUsed);
      
      return (
        <Select.Option
          key={pin}
          value={pin}
          disabled={isDisabled}
        >
          {pin}
        </Select.Option>
      );
    });
  })()}
</Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].enable} 
                <Tooltip title={translations[language].enableaçıklamamyşs} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Select
                value={float.enable}
                onChange={(value) => handleChange(index, 'enable', value, setFloats, floats)}
                style={{ width: '100%' }}
              >
                <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                <Select.Option value={"false"}>{translations[language].no}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].type} 
                <Tooltip title={translations[language].sensörtüpaçıklaama} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Select
                value={float.type}
                onChange={(value) => handleChange(index, 'type', value, setFloats, floats)}
                style={{ width: '100%' }}
              >
                <Select.Option value="0-190">0-190</Select.Option>
                <Select.Option value="240-33">240-33</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].purpose} 
                <Tooltip title={translations[language].purpeseeaçıklamaa} > 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Select
                value={float.purpose}
                onChange={(value) => handleChange(index, 'purpose', value, setFloats, floats)}
                style={{ width: '100%' }}
              >
                <Select.Option value="water">{translations[language].water}</Select.Option>
                <Select.Option value="drain">{translations[language].drain}</Select.Option>
                <Select.Option value="gray">{translations[language].gray}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
  label={
    <span>
      {translations[language].warnPercent}
      <Tooltip title={translations[language].uyarıverecekaçıklama}> 
        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
      </Tooltip>
    </span> 
  }
  name={`warn_percent_${index}`}
  dependencies={[`error_percent_${index}`]}   // 🔥 HİDRAFOR DEĞİŞİNCE BURASI DA TETİKLENİR
  rules={[
    ({ getFieldValue }) => ({
      validator: (_, value) => {
        const errorValue = getFieldValue(`error_percent_${index}`) ?? 0;
        const purpose = floats[index]?.purpose;

        if (value < 0) {
          return Promise.reject(new Error(translations[language].negatifdg || 'Negatif değer giremezsiniz'));
        }

        // TEMİZ SU → uyarı > hata
        if (purpose === 'water' && value <= errorValue) {
          return Promise.reject(new Error('Temiz su için uyarı yüzdesi hata yüzdesinden büyük olmalı'));
        }

        // KİRLİ / GRİ SU → uyarı < hata
        if ((purpose === 'drain' || purpose === 'gray') && value >= errorValue) {
          return Promise.reject(
            new Error(translations[language].kgsiu || 'Atık/gri su için uyarı yüzdesi hata yüzdesinden küçük olmalı')
          );
        }

        return Promise.resolve();
      }
    })
  ]}
  getValueProps={() => ({
    value: float.warn_percent ?? 20
  })}
  getValueFromEvent={(value) => parseFloat(value) || 20}
>
  <InputNumber
    min={0}
    onChange={(value) => handleChange(index, 'warn_percent', value, setFloats, floats)}
    style={{ width: '100%' }}
  />
</Form.Item>

          </Col>
          <Col span={8}>
<Form.Item 
  label={
    <span>
      {translations[language].errorPercent}
      <Tooltip title={translations[language].errorpensentaçıklama}> 
        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
      </Tooltip>
    </span> 
  }
  name={`error_percent_${index}`}
  dependencies={[`warn_percent_${index}`]}  // 🔥 UYARI YÜZDESİ DEĞİŞİNCE BURASI DA TETİKLENİR
  rules={[
    ({ getFieldValue }) => ({
      validator: (_, value) => {
        const warnValue = getFieldValue(`warn_percent_${index}`) ?? 0;
        const purpose = floats[index]?.purpose;

        if (value < 0) {
          return Promise.reject(new Error(translations[language].negatifdg || 'Negatif değer giremezsiniz'));
        }

        // TEMİZ SU → hata < uyarı
        if (purpose === 'water' && value >= warnValue) {
          return Promise.reject(new Error('Temiz su için hata yüzdesi uyarı yüzdesinden küçük olmalı'));
        }

        // KİRLİ / GRİ SU → hata > uyarı
        if ((purpose === 'drain' || purpose === 'gray') && value <= warnValue) {
          return Promise.reject(
            new Error(translations[language].kgsiu || 'Atık/gri su için hata yüzdesi uyarı yüzdesinden büyük olmalı')
          );
        }

        return Promise.resolve();
      }
    })
  ]}
  getValueProps={() => ({
    value: float.error_percent ?? 0
  })}
  getValueFromEvent={(value) => parseFloat(value) || 0}
>
  <InputNumber
    min={0}
    onChange={(value) => handleChange(index, 'error_percent', value, setFloats, floats)}
    style={{ width: '100%' }}
  />
</Form.Item>

          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].lock_pin}
                <Tooltip title={translations[language].lokpinaçıklama}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
<Select
  value={float.lock_pin}
  onChange={(value) => handleChange(index, 'lock_pin', value, setFloats, floats)}
  style={{ width: '100%' }}
  placeholder={translations[language].selectLockPin}
>
  <Select.Option value="">{translations[language].empty}</Select.Option>
  {enabledPins
    .filter(pin => !pin.endsWith('_2'))
    .map(pin => (
      <Select.Option
        key={pin}
        value={pin}
      >
        {pin}
      </Select.Option>
    ))}
</Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Dinamik Pozisyon Seçimi */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].page}
                <Tooltip title={translations[language].şamandırasayfanum}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`float_${index}_page`] ? 'error' : ''}>
              <Select
                value={float.page}
                onChange={(value) => handleChange(index, 'page', value, setFloats, floats)}
                style={{ width: '100%' }}
                status={fieldErrors[`float_${index}_page`] ? 'error' : undefined}
              >
                {pages.map((page) => (
                  <Select.Option key={page.no} value={page.no}>
                    {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].row}
                <Tooltip title={translations[language].şamandırasıranumarası}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`float_${index}_row`] ? 'error' : ''}>
              <Select
                value={float.row}
                onChange={(value) => handleChange(index, 'row', value, setFloats, floats)}
                style={{ width: '100%' }}
                disabled={!float.page}
                status={fieldErrors[`float_${index}_row`] ? 'error' : undefined}
              >
                {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].column}
                <Tooltip title={translations[language].kollonumarasışamadnıra}>
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                </Tooltip>
              </span>
            } validateStatus={fieldErrors[`float_${index}_column`] ? 'error' : ''}>
              <Select
                value={float.column}
                onChange={(value) => handleChange(index, 'column', value, setFloats, floats)}
                style={{ width: '100%' }}
                disabled={!float.page || !float.row}
                status={fieldErrors[`float_${index}_column`] ? 'error' : undefined}
              >
                {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            {float.cloneActive ? (
              <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneFloat(index)}>
                {translations[language].deleteClone} 
              </Button>
            ) : (
              <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneFloat(index)}>
                {translations[language].clone}
              </Button>
            )}
          </Col>
        </Row>

        {/* Clone Pozisyon Seçimi */}
        {float.cloneActive && (
          <Row gutter={16} style={{ 
            marginTop: '10px',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '12px', 
            backgroundColor: '#fafafa'
          }}>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].page2} 
                  <Tooltip title={translations[language].klonlasayfa} > 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip>
                </span> 
              }>
                <Select
                  value={float.page2}
                  onChange={(value) => handleChange(index, 'page2', value, setFloats, floats)}
                  style={{ width: '100%' }}
                >
                  {pages.map((page) => (
                    <Select.Option key={page.no} value={page.no}>
                      {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].row2}
                  <Tooltip title={translations[language].klonlasıranumarası} > 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip> 
                </span> 
              }>
                <Select
                  value={float.row2}
                  onChange={(value) => handleChange(index, 'row2', value, setFloats, floats)}
                  style={{ width: '100%' }}
                  disabled={!float.page2}
                >
                  {cloneRowOptions.map(r => (
                    <Select.Option key={r} value={r}>{r}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={
                <span>
                  {translations[language].column2}
                  <Tooltip title={translations[language].klonladasırakolonnumarası}> 
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                  </Tooltip>
                </span> 
              }>
                <Select
                  value={float.column2}
                  onChange={(value) => handleChange(index, 'column2', value, setFloats, floats)}
                  style={{ width: '100%' }}
                  disabled={!float.page2 || !float.row2}
                >
                  {cloneColumnOptions.map(c => (
                    <Select.Option key={c} value={c}>{c}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].icon}
                <Tooltip title= {translations[language].İkonaçıklama}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Button
                style={{ 
                  width: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  height: '30px',
                  backgroundColor: '#1890ff',
                  borderColor: '#1890ff',
                  color: 'white'
                }}
                onClick={() => {
                  setCurrentFloatIndex(index);
                  setIconModalVisible(true);
                }}
              >
                {icons[float.icon] && (
                  <img
                    src={icons[float.icon]}
                    alt={`icon ${float.icon}`}
                    style={{ 
                      width: '20px', 
                      height: '20px', 
                      marginRight: '8px' 
                    }}
                  />
                )}
                {float.icon}
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameTR}
                <Tooltip title={translations[language].açıklamatürkçe}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={float.nameTR}
                onChange={(e) => handleVoltageChangeForFloat(index, 'nameTR', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameGB}
                <Tooltip title={translations[language].açılamaIngülüzce}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={float.nameGB}
                onChange={(e) => handleVoltageChangeForFloat(index, 'nameGB', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={
              <span>
                {translations[language].nameDE}
                <Tooltip title={translations[language].açıklamaalmanca}> 
                  <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                </Tooltip>
              </span> 
            }>
              <Input
                value={float.nameDE}
                onChange={(e) => handleVoltageChangeForFloat(index, 'nameDE', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
                {selectedVersion !== "v2.08" && (
          <>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="İspanyolca İsim (ES)">
                  <Input 
                    value={float.nameES}
                    onChange={(e) => handleChange(index, 'nameES', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Rusça İsim (RU)">
                  <Input 
                    value={float.nameRU}
                    onChange={(e) => handleChange(index, 'nameRU', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Yunanca İsim (GR)">
                  <Input 
                    value={float.nameGR}
                    onChange={(e) => handleChange(index, 'nameGR', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
            </Row>
        
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Fransızca İsim (FR)">
                  <Input 
                    value={float.nameFR}
                    onChange={(e) => handleChange(index, 'nameFR', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="İtalyanca İsim (IT)">
                  <Input 
                    value={float.nameIT}
                    onChange={(e) => handleChange(index, 'nameIT', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Portekizce İsim (PT)">
                  <Input 
                    value={float.namePT}
                    onChange={(e) => handleChange(index, 'namePT', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
            </Row>
        
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Arapça İsim (SA)">
                  <Input 
                    value={float.nameSA}
                    onChange={(e) => handleChange(index, 'nameSA', e.target.value, setFloats, floats)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Card>
    );
  })}
  <Button 
  id="add-float-button"
  type="dashed" 
  onClick={handleAddFloat} 
  style={{ 
    marginBottom: '20px',
    backgroundColor: selectedComponentType === 'float' ? '#ff9800' : 'transparent',
    borderColor: selectedComponentType === 'float' ? '#ff9800' : '#d9d9d9',
    borderWidth: selectedComponentType === 'float' ? '2px' : '1px',
    color: selectedComponentType === 'float' ? 'white' : 'inherit',
    fontWeight: selectedComponentType === 'float' ? 'bold' : 'normal',
    transition: 'all 0.3s ease'
  }}
>
  {translations[language].addFloat}
</Button>
</Collapse.Panel>
                  {/* relay Section */}
                  <Collapse.Panel header={`${translations[language].relay}`} key="6">
  {relays.map((relay, index) => (
    <Card
      key={index}
      title={`${translations[language].relay}`}
      bordered
      style={{ marginBottom: '20px', borderRadius: '8px' }}
      extra={
        <Popconfirm
          title={translations[language].deleteConfirm}
          onConfirm={() => handleDeleteFloat(index)}
          okText={translations[language].yes}
          cancelText={translations[language].no}
        >
        </Popconfirm>
      }
    >
      {/* İlk satır - 3 sütun */}
      <Row gutter={16} style={{ marginBottom: '16px' }}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label={ <span>{translations[language].active}<Tooltip title={translations[language].röleaçıkalmalat}> 
                                            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                          </Tooltip></span>}>
            <Select
              value={relay.enable}
              onChange={(value) => handleChange(index, 'enable', value, setRelays, relays)}
              disabled={relaySocketPins.length <= 1}
              style={{ width: '100%' }}
            >
              <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
              <Select.Option value={"false"}>{translations[language].no}</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <Form.Item label={<span>{translations[language].shortCircuitSocketpin}<Tooltip title={translations[language].şortkatbirşeymişney}> 
                                            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                          </Tooltip></span> }>
            <Select
              value={relay.short_circuit_socketpin}
              onChange={(value) => handleRelayChange(index, 'short_circuit_socketpin', value)}
              disabled={relaySocketPins.length <= 1}
            >
              {relaySocketPins.map((pin) => {
                const isDisabled = pin === relay.open_circuit_socketpin;
                return (
                  <Select.Option key={pin} value={pin} disabled={isDisabled}>
                    {pin}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <Form.Item label={<span>{translations[language].openCircuitSocketpin}<Tooltip title={translations[language].açıkdevrebirşeymişneymişondan}> 
                                            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                          </Tooltip></span> }>
            <Select
              value={relay.open_circuit_socketpin}
              onChange={(value) => handleRelayChange(index, 'open_circuit_socketpin', value)}
              disabled={relaySocketPins.length <= 1}
            >
              {relaySocketPins.map((pin) => {
                const isDisabled = pin === relay.short_circuit_socketpin;
                return (
                  <Select.Option key={pin} value={pin} disabled={isDisabled}>
                    {pin}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* İkinci satır - 3 sütun */}
<Row gutter={16}>
  <Col xs={24} sm={12} md={8}>
    <Form.Item 
      label={<span>{translations[language].shortCircuitVoltage}<Tooltip title={translations[language].kısadevredurumdauygulanacak}> 
                                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                    </Tooltip></span> }
      name={`short_circuit_voltage_${index}`}
      getValueProps={(value) => ({ 
        value: value !== undefined ? value : (relay.short_circuit_voltage ? relay.short_circuit_voltage / 1000 : 13.2)
      })}
      getValueFromEvent={(value) => {
        if (typeof value === 'string') {
          value = value.replace(',', '.');
        }
        return parseFloat(value) || 13.2;
      }}
    >
      <InputNumber
        min={8}
        max={100}
        style={{ width: '100%' }}
        stringMode
        disabled={relaySocketPins.length <= 1}
        onChange={(value) => {
          if (typeof value === 'string') {
            value = value.replace(',', '.');
          }
          handleChange(index, 'short_circuit_voltage', parseFloat(value) * 1000, setRelays, relays);
        }}
        parser={(value) => value.replace(',', '.')}
      />
    </Form.Item>
  </Col>
  
  <Col xs={24} sm={12} md={8}>
    <Form.Item 
      label={<span>{translations[language].openCircuitVoltage}<Tooltip title={translations[language].açıkdevredurumuaçıklama}> 
                                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                    </Tooltip></span> }
      name={`open_circuit_voltage_${index}`}
      getValueProps={(value) => ({ 
        value: value !== undefined ? value : (relay.open_circuit_voltage ? relay.open_circuit_voltage / 1000 : 12.5)
      })}
      getValueFromEvent={(value) => {
        if (typeof value === 'string') {
          value = value.replace(',', '.');
        }
        return parseFloat(value) || 12.5;
      }}
    >
      <InputNumber
        min={8}
        max={100}
        style={{ width: '100%' }}
        stringMode
        disabled={relaySocketPins.length <= 1}
        onChange={(value) => {
          if (typeof value === 'string') {
            value = value.replace(',', '.');
          }
          handleChange(index, 'open_circuit_voltage', parseFloat(value) * 1000, setRelays, relays);
        }}
        parser={(value) => value.replace(',', '.')}
      />
    </Form.Item>
  </Col>
  
  <Col xs={24} sm={12} md={8}>
    <Form.Item 
      label={<span>{translations[language].manualOverrideDuration}<Tooltip title={translations[language].manuelmüdahalesanresi}> 
                                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                                    </Tooltip></span> }
      name={`manualoverride_duration_${index}`}
      getValueProps={(value) => ({ 
        value: value !== undefined ? value : (relay.manualoverride_duration ?? 75)
      })}
      getValueFromEvent={(value) => {
        return parseInt(value) || 75;
      }}
    >
      <InputNumber
        min={0}
        max={86400}
        style={{ width: '100%' }}
        disabled={relaySocketPins.length <= 1}
        onChange={(value) => {
          const parsedValue = Math.min(86400, Math.max(0, parseInt(value) || 0));
          handleChange(index, 'manualoverride_duration', parsedValue, setRelays, relays);
        }}
      />
    </Form.Item>
  </Col>
</Row>
    </Card>
  ))}
                  </Collapse.Panel>
                  {/* setting Section */}
                  <Collapse.Panel header={`${translations[language].setting}`} key="7">
  {settings.map((setting, index) => (
    <Card
      key={index}
      title={`${translations[language].setting}`}
      bordered
      style={{ marginBottom: '20px', borderRadius: '8px' }}
      extra={
        <Popconfirm
          title={translations[language].deleteConfirm}
          onConfirm={() => handleDeleteFloat(index)}
          okText={translations[language].yes}
          cancelText={translations[language].no}
        >
        </Popconfirm>
      }
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label={<span>{translations[language].forceShutDownVoltage}<Tooltip title={translations[language].sistemizrlakapat}> 
                                <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                              </Tooltip></span> }
            name={`force_shut_down_voltage_${index}`}
            rules={[
              {
                validator: (_, value) =>
                  value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
              },
            ]}
            getValueProps={(value) => ({ 
              value: value !== undefined ? value : (setting.force_shut_down_voltage ? setting.force_shut_down_voltage / 1000 : 10.5)
            })}
            getValueFromEvent={(value) => {
              if (typeof value === 'string') {
                value = value.replace(',', '.');
              }
              return parseFloat(value) || 10.5;
            }}
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: '100%' }}
              stringMode
              onChange={(value) => {
                if (typeof value === 'string') {
                  value = value.replace(',', '.');
                }
                handleChange(index, 'force_shut_down_voltage', parseFloat(value) * 1000, setSettings, settings);
              }}
              parser={(value) => value.replace(',', '.')}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={<span>{translations[language].optionalDownVoltage}<Tooltip title={translations[language].sistemizorlakapatmavoltaj}> 
                                <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                              </Tooltip></span>}
            name={`optional_down_voltage_${index}`}
            rules={[
              {
                validator: (_, value) =>
                  value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
              },
            ]}
            getValueProps={(value) => ({ 
              value: value !== undefined ? value : (setting.optional_down_voltage ? setting.optional_down_voltage / 1000 : 11)
            })}
            getValueFromEvent={(value) => {
              if (typeof value === 'string') {
                value = value.replace(',', '.');
              }
              return parseFloat(value) || 11;
            }}
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: '100%' }}
              stringMode
              onChange={(value) => {
                if (typeof value === 'string') {
                  value = value.replace(',', '.');
                }
                handleChange(index, 'optional_down_voltage', parseFloat(value) * 1000, setSettings, settings);
              }}
              parser={(value) => value.replace(',', '.')}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={<span>{translations[language].startWarnVoltage}<Tooltip title={translations[language].uyarıbaşlatmavoltajı}> 
                                <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                              </Tooltip></span> }
            name={`start_warn_voltage_${index}`}
            rules={[
              {
                validator: (_, value) =>
                  value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
              },
            ]}
            getValueProps={(value) => ({ 
              value: value !== undefined ? value : (setting.start_warn_voltage ? setting.start_warn_voltage / 1000 : 11.5)
            })}
            getValueFromEvent={(value) => {
              if (typeof value === 'string') {
                value = value.replace(',', '.');
              }
              return parseFloat(value) || 11.5;
            }}
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: '100%' }}
              stringMode
              onChange={(value) => {
                if (typeof value === 'string') {
                  value = value.replace(',', '.');
                }
                handleChange(index, 'start_warn_voltage', parseFloat(value) * 1000, setSettings, settings);
              }}
              parser={(value) => value.replace(',', '.')}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={<span>{translations[language].recoverVoltage}<Tooltip title={translations[language].kurtarmavoltajıaçıklama}> 
                                <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                              </Tooltip></span> }
            name={`recover_voltage_${index}`}
            rules={[
              {
                validator: (_, value) =>
                  value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
              },
            ]}
            getValueProps={(value) => ({ 
              value: value !== undefined ? value : (setting.recover_voltage ? setting.recover_voltage / 1000 : 12)
            })}
            getValueFromEvent={(value) => {
              if (typeof value === 'string') {
                value = value.replace(',', '.');
              }
              return parseFloat(value) || 12;
            }}
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: '100%' }}
              stringMode
              onChange={(value) => {
                if (typeof value === 'string') {
                  value = value.replace(',', '.');
                }
                handleChange(index, 'recover_voltage', parseFloat(value) * 1000, setSettings, settings);
              }}
              parser={(value) => value.replace(',', '.')}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label={<span>{translations[language].forceShutDownTime}<Tooltip title={translations[language].zorlakapatmaaçıklama}> 
                                <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                              </Tooltip></span> }
            name={`force_shut_down_time_${index}`}
            rules={[
              {
                validator: (_, value) =>
                  value < 0 || value > 600 
                    ? Promise.reject(new Error('Değer 0-600 arasında olmalıdır')) 
                    : Promise.resolve(),
              },
            ]}
            getValueProps={(value) => ({ 
              value: value !== undefined ? value : (setting.force_shut_down_time ?? 60)
            })}
            getValueFromEvent={(value) => {
              return parseInt(value) || 60;
            }}
          >
            <InputNumber
              min={0}
              max={600}
              style={{ width: '100%' }}
              onChange={(value) => handleChange(index, 'force_shut_down_time', value, setSettings, settings)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  ))}
</Collapse.Panel>
                  {/* Tempratures Section */}
                  <Collapse.Panel header = {translations[language].temprature} key="8">
                  {tempratures.map((temprature, index) =>(
                    <Card title = {`${translations[language].numberOfTemprature} ${temprature.no}`}  >
                    <Row gutter={16}>
  <Col span={8}>
    <Form.Item label={<span>{translations[language].isTempratureEnable} <Tooltip title={translations[language].sıcaklıksensörüaktifpasif}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip></span> }>
      <Select
        value={temprature.enable}
        onChange={(value) => handleChange(index, 'enable', value, setTempratures, tempratures)}
      >
        <Select.Option value="true">{translations[language].aktiftrue}</Select.Option>
        <Select.Option value="false">{translations[language].aktifalse}</Select.Option>
      </Select>
    </Form.Item>
    </Col>
    <Col span={8}>
    <Form.Item label={<span>{translations[language].location}<Tooltip title={translations[language].location}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip></span> }>
      <Select
        value={temprature.side}
        onChange={(value) => handleTemperatureSideChange(index, value)}
      >
        <Select.Option value="right">{translations[language].right}</Select.Option>
        <Select.Option value="left">{translations[language].left}</Select.Option>
      </Select>
    </Form.Item>
    </Col>
    <Col span={8}>
    <Form.Item label={<span>{translations[language].icon}<Tooltip title={translations[language].sıcaklıksensörüikon}> 
                        <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} /> 
                      </Tooltip></span> }>
    <Button
        style={{ 
          width: '100%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '30px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white'
        }}
        onClick={() => {
          setCurrentTempratureIndex(index);
          setIconModalVisible(true);
        }}
      >
        {icons[temprature.icon] && (
          <img
            src={icons[temprature.icon]}
            alt={`icon ${temprature.icon}`}
            style={{ 
              width: '20px', 
              height: '20px', 
              marginRight: '8px' 
            }}
          />
        )}
        {temprature.icon}
      </Button>
                  </Form.Item>
                  </Col>
                </Row>
                  </Card>
                  ))}
                  </Collapse.Panel>
              </Collapse>
            </Form>
            <Space style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
        <Input
        placeholder={translations[language].kag}
        value={configName}
        onChange={e => setConfigName(e.target.value)}
        required
        style={{ width: '250px' }}
      />
      <Button
        type="primary"
        onClick={handleSaveChanges}
        disabled={!configName}
      >
        {<span>{translations[language].dkvi}</span> }
      </Button>
      </Space>
          </Card>

          
        </div>
            <div style={{ 
          flex: '1', 
          minWidth: '600px',
          maxWidth: '50%',
          position: 'sticky',
          top: '20px',
          height: 'calc(100vh - 40px)',
          overflowY: 'auto',
          paddingLeft: '16px'
        }}>
          <Modal
  title={translations[language].bileşentipi}
  visible={isComponentTypeModalVisible}
  onCancel={() => {
    setIsComponentTypeModalVisible(false);
    setSelectedSlotInfo(null);
  }}
  footer={null}
  width={400}
>
  <div style={{ textAlign: 'center' }}>
    <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
      <strong>{translations[language].ssayfa} {selectedSlotInfo?.page}, {translations[language].Sıraaaa} {selectedSlotInfo?.row}, {translations[language].kolloonn} {selectedSlotInfo?.column}</strong>
      <br />
      <span style={{ fontSize: '13px' }}>{translations[language].eklemekisteidğinizbileşen}</span>
    </p>
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      <Button
        size="large"
        onClick={() => handleSelectComponentType('output')}
        style={{ 
          width: '100%', 
          height: '50px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white',
          fontSize: '15px',
          fontWeight: 'bold'
        }}
      >
        {translations[language]?.outputs || 'Çıkış'}
      </Button>
      
      <Button
        size="large"
        onClick={() => handleSelectComponentType('input')}
        style={{ 
          width: '100%', 
          height: '50px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white',
          fontSize: '15px',
          fontWeight: 'bold'
        }}
      >
        {translations[language]?.inputs || 'Giriş'}
      </Button>
      
      <Button
        size="large"
        onClick={() => handleSelectComponentType('voltage')}
        style={{ 
          width: '100%', 
          height: '50px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white',
          fontSize: '15px',
          fontWeight: 'bold'
        }}
      >
        {translations[language]?.voltages || 'Voltaj'}
      </Button>
      
      <Button
        size="large"
        onClick={() => handleSelectComponentType('float')}
        style={{ 
          width: '100%', 
          height: '50px',
          backgroundColor: '#1890ff',
          borderColor: '#1890ff',
          color: 'white',
          fontSize: '15px',
          fontWeight: 'bold'
        }}
      >
        {translations[language]?.floats || 'Şamandıra'}
      </Button>
    </Space>
  </div>
</Modal>
    <PanelPreview
      pages={pages}
      outputs={outputs}
      inputs={inputs}
      voltages={voltages}
      floats={floats}
      tempratures={tempratures}
      translations={translations}
      language={language}
      icons={icons}
      onComponentClick={handleComponentClick}
      onEmptySlotClick={handleEmptySlotClick}
      onPageSettingsChange={handlePageSettingsChangeFromPreview}
      onAddPage={handleAddPageFromPreview}
      onDeletePage={handleDeletePageFromPreview}
    />
  </div>
  </div>
          
        </div>
        <Modal
          title={translations[language].selectIcon}
          visible={iconModalVisible}
          onCancel={() => setIconModalVisible(false)}
          footer={null}
          bodyStyle={{ backgroundColor: '#1890ff', padding: '30px', minHeight: '300px', borderRadius: '10px' }}
          width={600}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
            {[...Array(100)].map((_, i) => (
              <div
                key={i}
                onClick={() => handleIconSelect(i)}
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #fff',
                  borderRadius: '10px',
                }}
              >
                <img src={icons[i]} alt={`icon ${i}`} style={{ width: '40px', height: '40px' }} />
              </div>
            ))}
          </div>
        </Modal>
        </ConfigProvider>
    </AppLayout>
  );
};
export default EditableJson;